var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useCallback, useEffect, useMemo, useState, } from "react";
import { useStyles } from "./assets/style";
import "./assets/style.css"; // @ts-ignore
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { themeCore } from "../../assets/themes/theme";
import * as catalogConst from "../../const/catalog";
import { STEP_CONFIRMATIONFORM } from "../../const/catalog";
import { formatPhoneNumber } from "../../utils/formats";
import { navigateNext, stepProgress } from "../../dataBase/stepProgress";
import { Customer } from "../../enum/customer";
import { Steps } from "../../enum/steps";
import { PostUploadDocuments } from "../../fnx/apaAuditDocuments/quoteUploadDocuments";
import { GetCatalogBeneficiary } from "../../fnx/catalog/getCatalogBeneficiary";
import { GetCatalogInsurance } from "../../fnx/catalog/getCatalogInsurance";
import { GetPaymentMode } from "../../fnx/paymentMode/getPaymentMode";
import { useCertificateQuote } from "../../fnx/certificate/certificateQuotes";
import { getCustomerAction, isAcap, isCustomer } from "../../fnx/customer";
import { GetPersonByDocument } from "../../fnx/person/getPersonByDocument";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { formatDocument, getLogin, transformToSelect, } from "../../services/functions";
import { hasPermission } from "../../services/getNavigationPages";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { postQuoteUploadDocumentClearData } from "../../store/apapUploadAttachments/actions";
import { benefitClearData, getBeneficiary, patchBeneficiaryClearData, } from "../../store/beneficiary/actions";
import { certificateQuoteClearData } from "../../store/certificates/actions";
import { countries } from "../../store/countries/actions";
import { quoteClearData, quoteOne } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { deleteInsured as deleteInsuredAction, deleteInsuredClearData, insured, patchInsuredClearData, postInsuredClearData, } from "../../store/insured/actions";
import { pageActionFlagsClearData } from "../../store/pageActionFlags/actions";
import { personByDocumentClearData } from "../../store/person/actions";
import { catalogGender } from "../../store/plan/actions";
import { plans } from "../../store/plans/actions";
import { projectOne, projectOneClearData } from "../../store/project/actions";
import { region } from "../../store/region/actions";
import { Branches } from "../../store/branches/actions";
import { patchQuoteClearData } from "../../store/updateQuote/actions";
import { patchQuoteAPI } from "../../resources/helper/updateQuote";
import { formattedDate, newFormattedDate } from "../../utils/date";
import { formatNumberCustom, formatToTwoDecimals, parsePrice, } from "../../utils/getPrice";
import { AdditionalDocumentationColumns, dataEditVehicleForm, rowsClientDocument, StatementColumns, Tab1Columns, Tab2Columns, Tab3Columns, Tab4Columns, TabAppointmentColumns, TabAppointmentManagerColumns, TabAutoColumns, } from "./resources/confirmationFormDto";
import { ConfirmationFormView } from "./ui/view"; /* Beneficiary */
import useBeneficiary from "./components/beneficiary"; /* Insurance */
import useInsurance from "./components/insurance"; /* Vehicle */
import useVehicle from "./components/vehicle"; /* ConfirmationForm */
import useClient from "./components/client"; /* Form Actions */
import useActions from "./components/ui"; /* Selectors */
import useSelectors from "./components/selectors"; /* Functions */
import useFunctions from "./components/functions";
import { PassengerDownloadModal } from "./resources/PassengerDownloadModal";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { ConfirmationHeader } from "./header";
import { addStepInformationToAllSteps, useGetInformationSteps, } from "ah_utility/workflow";
import { useGetSummary } from "../../utils/getSummary";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { formAddBusiness } from "./resources/FormsBusinessDTO";
import { useCatalogues } from "../addBusiness/hooks/useCatalogues";
import { useStartWokFlow } from "../../fnx/workFlow/startWorkFlow";
import { startWorkFlowClearData } from "../../store/workFlow/actions";
import { policyConfirm, policyConfirmClearData, } from "../../store/policy/actions";
import { addToSummary } from "ah_utility/fnxUtils";
import usePaymentConfirmation from "../paymentConfirmation/components/paymentConfirmation";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { useAppointment } from "./hooks/useAppointment";
import { useAppointmentManager } from "./hooks/useAppointmentManager";
import { useQuoteComments } from "./hooks/useQuoteComments";
import { useAuditLogs } from "./hooks/useAuditLogs";
var STEP = STEP_CONFIRMATIONFORM;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey3 = "afy-action-flags";
var lsPageActionFlags = new LocalStorageService(storageKey3);
var storageKey4 = "afy-steps";
var lsSteps = new LocalStorageService(storageKey4);
var ConfirmationForm = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
    var permissions = {
        create: hasPermission("sale-confirmation-form-create"),
    };
    // -- DATA & STATES BUSINESS HOME
    var _9 = React.useState(false), openModalAddBusiness = _9[0], setOpenModalAddBusiness = _9[1];
    var _10 = React.useState(false), showTabRealEstates = _10[0], setShowTabRealEstates = _10[1];
    var _11 = useState(formAddBusiness), dataFormBusiness = _11[0], setDataFormBusiness = _11[1];
    var _12 = React.useState(false), isCommerce = _12[0], setIsCommerce = _12[1];
    var _13 = useState(""), provinceId = _13[0], setProvinceId = _13[1];
    var _14 = useState(""), townId = _14[0], setTowId = _14[1];
    var _15 = useState(""), sectorId = _15[0], setSectorId = _15[1];
    var _16 = useState(""), planCode = _16[0], setPlanCode = _16[1];
    var _17 = useState(""), productCode = _17[0], setProductCode = _17[1];
    var _18 = useState([]), rowsProperties = _18[0], setRowsProperties = _18[1];
    var _19 = useState(""), propertyTypeId = _19[0], setPropertyTypeId = _19[1];
    var _20 = React.useState(""), damageBackup = _20[0], setDamageBackup = _20[1];
    var _21 = React.useState(""), insuredProperty = _21[0], setInsuredProperty = _21[1];
    // HOME
    var _22 = React.useState(false), openModalAddHome = _22[0], setOpenModalAddHome = _22[1];
    var _23 = React.useState(false), showFormBusiness = _23[0], setShowFormBusiness = _23[1];
    // -- END DATA & STATES BUSINESS HOME
    //APPOINMENT
    var _24 = React.useState(false), showTabAppointment = _24[0], setShowTabAppointment = _24[1];
    var _25 = React.useState(false), showTabAppointmentManager = _25[0], setShowTabAppointmentManager = _25[1];
    var _26 = React.useState(true), addAppointmentAction = _26[0], setAddAppointmentAction = _26[1];
    var _27 = React.useState(false), openModalAddAppointmentAction = _27[0], setOpenModalAddAppointmentAction = _27[1];
    var t = useTranslation().t;
    var classes = useStyles();
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _28 = React.useState(lsPageActionFlags.getPageActionFlagsStored()), actionFlags = _28[0], setActionFlags = _28[1];
    var _29 = useState(""), planId = _29[0], setPlanId = _29[1];
    var _30 = React.useState(false), openDrawerUpload = _30[0], setOpenDrawerUpload = _30[1];
    var _31 = React.useState(""), idDocumentClient = _31[0], setIdDocumentClient = _31[1];
    var _32 = useState(""), coverTypeId = _32[0], setCoverTypeId = _32[1];
    var _33 = useState(""), campaignId = _33[0], setCampaignId = _33[1];
    var _34 = useState(""), catalogPaymentMode = _34[0], setCatalogPaymentMode = _34[1];
    var _35 = useState(""), catalogStatusQuote = _35[0], setCatalogStatusQuote = _35[1];
    var _36 = useState(""), policyStatus = _36[0], setPolicyStatus = _36[1];
    var _37 = useState([]), paymentMethodCardData = _37[0], setPaymentMethodCardData = _37[1];
    var _38 = useState(""), branchId = _38[0], setBranchId = _38[1];
    var userId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _39 = React.useState(false), uploadTrigger = _39[0], setUploadTrigger = _39[1];
    var isVidaTermino = isCustomer(Customer.VIDA);
    var _40 = React.useState(""), period = _40[0], setPeriod = _40[1];
    var _41 = React.useState([]), breadCrumbs = _41[0], setBreadCrumbs = _41[1];
    var _42 = React.useState(false), showInsured = _42[0], setShowInsured = _42[1];
    var _43 = React.useState(false), showNewFormInsurance = _43[0], setShowNewFormInsurance = _43[1];
    var _44 = React.useState(false), showBeneficiary = _44[0], setShowBeneficiary = _44[1];
    var _45 = React.useState(true), addInsured = _45[0], setAddInsured = _45[1];
    var _46 = React.useState(true), addBeneficiary = _46[0], setAddBeneficiary = _46[1];
    var _47 = React.useState(false), showComponent = _47[0], setShowComponent = _47[1];
    var _48 = useState(false), openModalBackConfirm = _48[0], setOpenModalBackConfirm = _48[1];
    var _49 = React.useState(true), canEdit = _49[0], setCanEdit = _49[1];
    var _50 = React.useState(false), showDownloads = _50[0], setShowDownloads = _50[1];
    var _51 = React.useState(false), canEditLocation = _51[0], setCanEditLocation = _51[1];
    var _52 = React.useState(false), canEditContact = _52[0], setCanEditContact = _52[1];
    var _53 = React.useState([]), certificates = _53[0], setCertificates = _53[1];
    var _54 = useState([]), rows = _54[0], setRows = _54[1];
    var _55 = useState([]), rows2 = _55[0], setRows2 = _55[1];
    var _56 = useState([]), rowsBeneficiary = _56[0], setRowsBeneficiary = _56[1];
    var _57 = useState([]), rowsPassengers = _57[0], setRowsPassengers = _57[1];
    var _58 = React.useState(false), openActivePolicy = _58[0], setOpenActivePolicy = _58[1];
    var activatePolicy = useParams().activatePolicy;
    var showButtonActivatePolicy = React.useState(!!activatePolicy)[0];
    var _59 = React.useState(""), policyId = _59[0], setPolicyId = _59[1];
    var _60 = React.useState(false), hideMarriedName = _60[0], setHideMarriedName = _60[1];
    var _61 = React.useState(""), namePlan = _61[0], setNamePlan = _61[1];
    var _62 = useState(false), isMaskedDocument = _62[0], setIsMaskedDocument = _62[1];
    var _63 = useState(""), personQuoteId = _63[0], setPersonQuoteId = _63[1];
    var _64 = useState(""), prime = _64[0], setPrime = _64[1];
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _65 = React.useState(true), enable = _65[0], setEnable = _65[1];
    var _66 = React.useState([]), listIdentificationType = _66[0], setListIdentificationType = _66[1];
    var _67 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _67[0], setSeeToast = _67[1];
    var id = useParams().id;
    var isQuote = useParams().isQuote;
    var isPlan = useParams().isPlan;
    var idProject = useParams().idProject;
    var isDocumentClient = useParams().isDocumentClient;
    var _68 = React.useState(false), projectTrigger = _68[0], setProjectTrigger = _68[1];
    var _69 = React.useState(false), triggerCatalog = _69[0], setTriggerCatalog = _69[1];
    var _70 = React.useState(false), triggerCatalogInsurance = _70[0], setTriggerCatalogInsurance = _70[1];
    var _71 = React.useState(false), triggerPaymentMode = _71[0], setTriggerPaymentMode = _71[1];
    var _72 = React.useState(false), triggerCertificate = _72[0], setTriggerCertificate = _72[1];
    var _73 = useState([]), listGenders = _73[0], setListGenders = _73[1];
    var _74 = useState(isQuote === "true"), isQuoteType = _74[0], setIsQuoteType = _74[1];
    var _75 = useState(true), canEditBeneficiary = _75[0], setCanEditBeneficiary = _75[1];
    var _76 = useState(true), canEditInsured = _76[0], setCanEditInsured = _76[1];
    var _77 = useState([]), listCountries = _77[0], setListCountries = _77[1];
    var _78 = useState([]), listRegionLevel1 = _78[0], setListRegionLevel1 = _78[1];
    var _79 = useState([]), listRegionLevel2 = _79[0], setListRegionLevel2 = _79[1];
    var _80 = useState([]), listRegionLevel3 = _80[0], setListRegionLevel3 = _80[1];
    var _81 = React.useState(1), page = _81[0], setPage = _81[1];
    var _82 = React.useState(""), idQuoteVehicle = _82[0], setIdQuoteVehicle = _82[1];
    var _83 = React.useState(""), productId = _83[0], setProductId = _83[1];
    var _84 = React.useState(10000), limit = _84[0], setLimit = _84[1];
    var _85 = React.useState(false), openModal = _85[0], setOpenModal = _85[1];
    var _86 = React.useState(false), openModalAddInsurance = _86[0], setOpenModalAddInsurance = _86[1];
    var _87 = React.useState(false), openModalPdfViewer = _87[0], setopenModalPdfViewer = _87[1];
    var _88 = React.useState(""), urlDocument = _88[0], setUrlDocument = _88[1];
    var _89 = React.useState(""), nameDocument = _89[0], setNameDocument = _89[1];
    var _90 = React.useState(""), personId = _90[0], setPersonId = _90[1];
    var _91 = React.useState(false), openModalBeneficiary = _91[0], setOpenModalBeneficiary = _91[1];
    var _92 = React.useState(transformToSelect(localStorageService.getStepStored().steps[Steps.plan].paymentMode)), paymentMode = _92[0], setPaymentMode = _92[1];
    var _93 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), coverageType = _93[0], setCoverageType = _93[1];
    var _94 = React.useState([
        { id: 1, name: "Sin datos", value: "-1", code: "" },
    ]), insuredType = _94[0], setInsuredType = _94[1];
    var _95 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), beneficiaryType = _95[0], setBeneficiaryType = _95[1];
    var _96 = React.useState(findParamInLocalStorage("campaign", "steps")), campaign = _96[0], setCampaign = _96[1];
    var _97 = React.useState(findParamInLocalStorage("campaign", "steps")), campaigns = _97[0], setCampaigns = _97[1];
    var _98 = React.useState(""), planName = _98[0], setPlanName = _98[1];
    var _99 = React.useState({
        id: "",
        name: "",
        value: "",
    }), campaignSelected = _99[0], setCampaignSelected = _99[1];
    var _100 = React.useState({
        id: "",
        name: "",
    }), plan = _100[0], setPlan = _100[1];
    var _101 = React.useState(false), openModalEditVehicle = _101[0], setOpenModalEditVehicle = _101[1];
    var steps = useGetSteps();
    var _102 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
        },
        data: [],
    }), planData = _102[0], setPlanData = _102[1];
    var _103 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaignInfo = _103[0], setCampaignInfo = _103[1];
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var _104 = React.useState(), coverType = _104[0], setCoverType = _104[1];
    var _105 = useState("Confirmación de Datos"), titleInsured = _105[0], setTitleInsured = _105[1];
    var _106 = useState("Ingresar beneficiario"), titleBeneficiary = _106[0], setTitleBeneficiary = _106[1];
    var _107 = React.useState(findParamInLocalStorage("projectId") || ""), projectId = _107[0], setProjectId = _107[1];
    var _108 = React.useState(false), isTravelInsurance = _108[0], setIsTravelInsurance = _108[1];
    // Get passenger counts from localStorage and calculate sum
    var edad020 = parseInt(findParamInLocalStorage("edad020") || "0");
    var edad2174 = parseInt(findParamInLocalStorage("edad2174") || "0");
    var edad7585 = parseInt(findParamInLocalStorage("edad7585") || "0");
    var _109 = React.useState(edad020 + edad2174 + edad7585), premiumSum = _109[0], setPremiumSum = _109[1];
    var _110 = useState(false), isUpdate = _110[0], setIsUpdate = _110[1];
    var _111 = React.useState(dataEditVehicleForm), dataFormVehicle = _111[0], setDataFormVehicle = _111[1];
    var _112 = useState({
        DocumentNumber: "",
        QuoteNumber: "",
        QuoteStatusName: "",
        QuoteDate: "",
        Type: "",
        PlanTypeName: "",
        CampaignName: "-",
        IdTypeName: "",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        SecondLastName: "",
        MarriedSurName: "-",
        Gender: "",
        Birthday: "",
        Address1: "-",
        Address2: "-",
        CountryName: "",
        ProvinceName: "",
        TownName: "",
        SectorName: "",
        PostalCode: "",
        PhoneOffice: "",
        PhoneHome: "-",
        PhoneNumber: "-",
        Email: "",
    }), dataForm = _112[0], setDataForm = _112[1];
    var _113 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        Percentage: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormBeneficiary = _113[0], setDataFormBeneficiary = _113[1];
    var _114 = useState({
        Id: "",
        IdType: "",
        idInsuredType: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormInsurance = _114[0], setDataFormInsurance = _114[1];
    var _115 = useState({
        idType: "",
        documentNumber: "",
        idInsuredType: "",
        firstName: "",
        secondName: "",
        lastNameA: "",
        lastNameB: "",
        birthday: "",
        gender: "",
        marriedName: "",
        country: "",
        province: "",
        town: "",
        sector: "",
        postalCode: "",
        address1: "",
        phoneHome: "",
        phoneNumber: "",
        phoneOffice: "",
        email: "",
    }), dataFormInsuranceSp = _115[0], setDataFormInsuranceSp = _115[1];
    var _116 = useState(""), insuranceType = _116[0], setInsuranceType = _116[1];
    var _117 = useState(45), initialPercentage = _117[0], setInitialPercentage = _117[1];
    var _118 = useState(false), trigger = _118[0], setTrigger = _118[1];
    var _119 = useState(), document = _119[0], setDocument = _119[1];
    var _120 = useState(false), isInsurance = _120[0], setIsInsurance = _120[1];
    var _121 = useState([]), listVehiclesDetail = _121[0], setListVehicles = _121[1];
    var _122 = React.useState({}), salesFlow = _122[0], setSalesFlow = _122[1];
    var _123 = React.useState([]), statementRows = _123[0], setStatementRows = _123[1];
    var _124 = React.useState([]), filters = _124[0], setFilters = _124[1];
    var _125 = React.useState([]), defaultFilters = _125[0], setDefaultFilters = _125[1];
    var _126 = React.useState(rowsClientDocument), profileDocumentsRows = _126[0], setProfileDocumentsRows = _126[1];
    var _127 = React.useState(0), countBadge = _127[0], setCountBadge = _127[1];
    var carDetails = React.useState((_a = lsSteps.getStepStored().steps[Steps.vehiclesDetails]) === null || _a === void 0 ? void 0 : _a.vehiclesDetails)[0];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var isApapAuto = getCustomerAction().customerAuto.includes(company);
    var isAcapCompany = isAcap(company);
    var _128 = useState(true), hideTabDocumentClient = _128[0], setHideTabDocumentClient = _128[1];
    var _129 = useState(true), hideTabPaymentInfo = _129[0], setHideTabPaymentInfo = _129[1];
    var isNotQuote = isQuote !== "false";
    var isApapAutoWithoutQuote = isApapAuto && !isNotQuote;
    var _130 = React.useState(""), fileName = _130[0], setFileName = _130[1];
    var _131 = React.useState(), pdfFile = _131[0], setPdfFile = _131[1];
    var _132 = React.useState(false), modalDocumentClient = _132[0], setModalDocumentClient = _132[1];
    var _133 = React.useState(""), urlDocumentClient = _133[0], setUrlDocumentClient = _133[1];
    var _134 = React.useState("false"), docName = _134[0], setDocName = _134[1];
    var _135 = React.useState(false), openModalPassenger = _135[0], setOpenModalPassenger = _135[1];
    var _136 = React.useState(""), urlDocumentPassenger = _136[0], setUrlDocumentPassenger = _136[1];
    var _137 = React.useState(""), nameDocumentPassenger = _137[0], setNameDocumentPassenger = _137[1];
    var _138 = React.useState(((_b = localStorageService.getStepStored().steps[Steps.customer]) === null || _b === void 0 ? void 0 : _b.paymentModeSelected) || { id: "", name: "", value: "" }), paymentModelSelected = _138[0], setPaymentModelSelected = _138[1];
    var _139 = React.useState(localStorageService.getStepStored().steps[Steps.customer].coverType), coverTypeSelected = _139[0], setCoverTypeSelected = _139[1];
    var _140 = useState(""), productType = _140[0], setProductType = _140[1];
    var projectTypeLocal = React.useRef((_d = (_c = lsSteps.getStepStored().steps[Steps.insurance].flow) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.navigation.productType);
    var didMountRef = React.useRef(false);
    var _141 = useState(""), quoteId = _141[0], setQuoteId = _141[1];
    var isApap = getCustomerAction().customerAuto.includes(company);
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteIdLS = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var summary = useGetSummary();
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _142 = React.useState({}), sessionData = _142[0], setSessionData = _142[1];
    var _143 = React.useState(false), triggerStart = _143[0], setTriggerStart = _143[1];
    var workFlow = localStorage.getItem("WorkFlowId");
    var _144 = useState(""), instanceIdR = _144[0], setInstanceIdR = _144[1];
    var _145 = useState(""), currentStepId = _145[0], setCurrentStepId = _145[1];
    var _146 = React.useState(""), email = _146[0], setEmail = _146[1];
    var _147 = useState(""), nextStepId = _147[0], setNextStepId = _147[1];
    // ✅ Flag para refrescar la información de los pasos
    var _148 = useState(0), refreshStepsInfo = _148[0], setRefreshStepsInfo = _148[1];
    var _149 = React.useState([]), referrerRows = _149[0], setReferrerRows = _149[1];
    var _150 = useStepNavigation({
        currentStepId: pathLocation,
        sessionData: sessionData,
        autoValidate: true,
    }), navigation = _150.navigation, isLastPage = _150.isLastPage;
    // ✅ Ahora pasa el refreshTrigger para recargar cuando cambie
    var _151 = useGetInformationSteps(pathLocation, { refreshTrigger: refreshStepsInfo }), instanceId = _151.instanceId, workFlowId = _151.workFlowId, currentStep = _151.currentStep, nextStep = _151.nextStep;
    // Ref para controlar si ya se inicializó el país una vez
    var countryInitializedRef = React.useRef(false);
    var actionFlagsFound = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlagsFound === null || actionFlagsFound === void 0 ? void 0 : actionFlagsFound.find(function (flag) { return flag.name === "afy-confirm-filter-insurances-by-plan"; });
    var flagFilterInsuranceTypeByPlan = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var shouldFilterByCoverType = coverTypeId === "43430f8b-8fe3-4582-8d11-6f9edf69bb9e" &&
        flagFilterInsuranceTypeByPlan;
    var planIdForCatalog = shouldFilterByCoverType ? planId : undefined;
    var _152 = useState([]), downloadsStatusDenyList = _152[0], setDownloadsStatusDenyList = _152[1];
    var _153 = useState([]), showTabPaymentStatusAllowList = _153[0], setShowTabPaymentStatusAllowList = _153[1];
    var _154 = useState(false), isThereTabPaymentStatusAllowList = _154[0], setIsThereShowTabPaymentStatusAllowList = _154[1];
    var showComments = true;
    var showLogsInfo = true;
    var showTabReferrer = (_e = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) {
        return f.name === "afy-confirm-data-show-tab-referrer" && f.value === "true";
    })) !== null && _e !== void 0 ? _e : false;
    var hideChangeButton = (_f = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) { return f.name === "afy-do-not-change-policy" && f.value === "true"; })) !== null && _f !== void 0 ? _f : false;
    var sendProductCode = (_g = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) {
        return f.name === "afy-confirm-send-productCode" && f.value === "true";
    })) !== null && _g !== void 0 ? _g : false;
    var _155 = React.useState([]), holidays = _155[0], setHolidays = _155[1];
    var _156 = React.useState(""), rolAsesorid = _156[0], setRolAsesorId = _156[1];
    var _157 = useSelectors(), loadingUpdateQuote = _157.loadingUpdateQuote, errorUpdateQuote = _157.errorUpdateQuote, responseIdentificationType = _157.responseIdentificationType, errorIdentificationType = _157.errorIdentificationType, responseCatalogGender = _157.responseCatalogGender, errorCatalogGender = _157.errorCatalogGender, responsePlan = _157.responsePlan, errorPlan = _157.errorPlan, loading = _157.loading, responseCountries = _157.responseCountries, errorCountries = _157.errorCountries, responseRegion = _157.responseRegion, errorRegion = _157.errorRegion, responsePlans = _157.responsePlans, errorPlans = _157.errorPlans, loadingPlans = _157.loadingPlans, responseInsured = _157.responseInsured, errorInsured = _157.errorInsured, responseDeleteInsured = _157.responseDeleteInsured, errorDeleteInsured = _157.errorDeleteInsured, loadingDeleteInsured = _157.loadingDeleteInsured, responsePostInsured = _157.responsePostInsured, errorPostInsured = _157.errorPostInsured, loadingPostInsured = _157.loadingPostInsured, responsePatchInsured = _157.responsePatchInsured, errorPatchInsured = _157.errorPatchInsured, loadingPatchInsured = _157.loadingPatchInsured, responseUpdatePerson = _157.responseUpdatePerson, errorUpdatePerson = _157.errorUpdatePerson, loadingUpdatePerson = _157.loadingUpdatePerson, responseBenefit = _157.responseBenefit, errorBenefit = _157.errorBenefit, loadingBenefit = _157.loadingBenefit, responsePatchBeneficiary = _157.responsePatchBeneficiary, errorPatchBeneficiary = _157.errorPatchBeneficiary, loadingPatchBeneficiary = _157.loadingPatchBeneficiary, responseBeneficiary = _157.responseBeneficiary, errorBeneficiary = _157.errorBeneficiary, loadingBeneficiary = _157.loadingBeneficiary, responsePageActionFlags = _157.responsePageActionFlags, responseOneProject = _157.responseOneProject, loadingOneProject = _157.loadingOneProject, errorOneQuote = _157.errorOneQuote, responseOneQuote = _157.responseOneQuote, loadingOneQuote = _157.loadingOneQuote, loadingInsured = _157.loadingInsured, responsePatchQuote = _157.responsePatchQuote, errorPatchQuote = _157.errorPatchQuote, loadingPatchQuote = _157.loadingPatchQuote, responsePolicyConfirmLoading = _157.responsePolicyConfirmLoading, responsePolicyConfirm = _157.responsePolicyConfirm, responsePolicyConfirmError = _157.responsePolicyConfirmError;
    var updateVehicle = useVehicle(setOpenModalEditVehicle).updateVehicle;
    var _158 = useClient(paymentMode, setPeriod, setPaymentModelSelected, setPaymentMode, paymentModelSelected, coverTypeSelected, plans, enable, page, limit, projectId, namePlan, clientId, setCoverTypeSelected, campaigns, setCampaignSelected, level2, level3, setListRegionLevel3, listGenders, setHideMarriedName, setCoverType, setPlan, campaignSelected, personQuoteId, hideMarriedName, salesFlow, setCampaign, setCampaigns, setFileName, setPdfFile, setUploadTrigger, actionFlags, isQuote, setShowInsured, setAddInsured, setShowBeneficiary, setAddBeneficiary, setCanEditInsured, setCanEditBeneficiary, responseOneQuote, setTriggerCertificate, setUrlDocument, setopenModalPdfViewer, catalogPaymentMode, setDataForm, setDefaultFilters, setPrime, dataForm, setShowNewFormInsurance, setShowTabRealEstates, setShowFormBusiness, setShowTabAppointment, setShowTabAppointmentManager, (_h = id !== null && id !== void 0 ? id : quoteId) !== null && _h !== void 0 ? _h : "", userId), searchPerson = _158.searchPerson, handleSearch = _158.handleSearch, callDispatchPlan = _158.callDispatchPlan, callDispatchPlanAfterQuoteLoaded = _158.callDispatchPlanAfterQuoteLoaded, handleOnChangePaymentMethod = _158.handleOnChangePaymentMethod, handleOnChangeCoverType = _158.handleOnChangeCoverType, handleOnChangeCampaign = _158.handleOnChangeCampaign, handleChangeSelect = _158.handleChangeSelect, handleChangeSelectFormInsurance = _158.handleChangeSelectFormInsurance, handleUpdatePerson = _158.handleUpdatePerson, handleDownload = _158.handleDownload, updateDataFormPerson = _158.updateDataFormPerson, setCoverTypeStorybook = _158.setCoverTypeStorybook, handleOnClickAcquire = _158.handleOnClickAcquire, quoteUploadDocuments = _158.quoteUploadDocuments, callQuoteOne = _158.callQuoteOne, getActionFlags = _158.getActionFlags, handleOnClickAutoDownload = _158.handleOnClickAutoDownload, handleOnClickAutoDownloadVida = _158.handleOnClickAutoDownloadVida, setLocalStorage = _158.setLocalStorage, callDispatchPageActionFlags = _158.callDispatchPageActionFlags, showVehicleData = _158.showVehicleData, showDownloadQuote = _158.showDownloadQuote, showDownloadRequest = _158.showDownloadRequest;
    var branchesData = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Branches) === null || _a === void 0 ? void 0 : _a.responseBranches) === null || _b === void 0 ? void 0 : _b.data; });
    var loadingBranches = useSelector(function (state) { var _a; return (_a = state.Branches) === null || _a === void 0 ? void 0 : _a.loadingBranches; });
    useEffect(function () {
        if (clientId) {
            dispatch(Branches({
                enable: true,
                page: 1,
                limit: 100,
                clientId: clientId,
            }));
        }
    }, [clientId, dispatch]);
    var branchSwitcherOptions = useMemo(function () {
        var _a;
        var mapBranch = function (b) { return ({
            id: b.id,
            name: "".concat(b.code, " - ").concat(b.name),
            value: b.id,
        }); };
        if (Array.isArray(branchesData) && branchesData.length > 0) {
            return branchesData.map(mapBranch);
        }
        var q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
        var bd = q === null || q === void 0 ? void 0 : q.branchData;
        if ((q === null || q === void 0 ? void 0 : q.branch) && bd && (bd.name != null || bd.code != null)) {
            return [
                {
                    id: q.branch,
                    name: bd.code != null && bd.name
                        ? "".concat(bd.code, " - ").concat(bd.name)
                        : bd.name || String((_a = bd.code) !== null && _a !== void 0 ? _a : ""),
                    value: q.branch,
                },
            ];
        }
        return [];
    }, [branchesData, responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data]);
    var branchDisplayLabelForSwitcher = (_l = (_k = (_j = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _j === void 0 ? void 0 : _j.branchData) === null || _k === void 0 ? void 0 : _k.name) !== null && _l !== void 0 ? _l : "";
    var handleBranchChange = useCallback(function (newBranchId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentQuote, effectiveQuoteId, planIdBody, coverTypeIdBody, campaignIdBody, catalogPaymentModeBody, catalogStatusQuoteBody, _a;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    currentQuote = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
                    effectiveQuoteId = id !== null && id !== void 0 ? id : quoteId;
                    if (!currentQuote ||
                        !effectiveQuoteId ||
                        !userId ||
                        !((_b = currentQuote.catalogStatusQuote) === null || _b === void 0 ? void 0 : _b.id)) {
                        return [2 /*return*/];
                    }
                    planIdBody = (_c = currentQuote.planId) === null || _c === void 0 ? void 0 : _c.id;
                    coverTypeIdBody = (_d = currentQuote.coverType) === null || _d === void 0 ? void 0 : _d.id;
                    campaignIdBody = (_e = currentQuote.campaignId) === null || _e === void 0 ? void 0 : _e.id;
                    catalogPaymentModeBody = (_f = currentQuote.catalogPaymentMode) === null || _f === void 0 ? void 0 : _f.id;
                    catalogStatusQuoteBody = (_g = currentQuote.catalogStatusQuote) === null || _g === void 0 ? void 0 : _g.id;
                    if (!planIdBody ||
                        !coverTypeIdBody ||
                        !campaignIdBody ||
                        !catalogPaymentModeBody ||
                        !catalogStatusQuoteBody) {
                        return [2 /*return*/];
                    }
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, patchQuoteAPI({
                            planId: planIdBody,
                            coverTypeId: coverTypeIdBody,
                            campaignId: campaignIdBody,
                            catalogPaymentMode: catalogPaymentModeBody,
                            catalogStatusQuote: catalogStatusQuoteBody,
                            branchId: newBranchId,
                            userId: userId,
                        }, effectiveQuoteId)];
                case 2:
                    _h.sent();
                    callQuoteOne(effectiveQuoteId);
                    showToastSuccessMessage("Sucursal actualizada.", typeAlert.success, setSeeToast);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _h.sent();
                    showToastSuccessMessage("No se pudo cambiar la sucursal.", typeAlert.error, setSeeToast);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [responseOneQuote, id, quoteId, userId, callQuoteOne, setSeeToast]);
    var _159 = useInsurance(setTitleInsured, setIsUpdate, setOpenModal, setOpenModalAddInsurance, dataFormInsurance, setDataFormInsurance, dataFormInsuranceSp, setDataFormInsuranceSp, insuranceType, setRows, responseOneQuote, quoteId ? quoteId : id, clientId, personId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType, insuredType, setIsInsurance, setDocument, setTrigger, showNewFormInsurance, setSeeToast), handleAddInsured = _159.handleAddInsured, setInsuranceStorybook = _159.setInsuranceStorybook, handleSubmitInsured = _159.handleSubmitInsured, editInsured = _159.editInsured, searchInsurancePerson = _159.searchInsurancePerson;
    var _160 = useBeneficiary(setIsUpdate, setInitialPercentage, setTitleBeneficiary, setOpenModalBeneficiary, dataFormBeneficiary, setDataFormBeneficiary, initialPercentage, responseOneQuote, clientId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType), setBeneficiaryStorybook = _160.setBeneficiaryStorybook, handleAddBeneficiary = _160.handleAddBeneficiary, handleSubmitBeneficiary = _160.handleSubmitBeneficiary, getInsuredBeneficiary = _160.getInsuredBeneficiary, editBeneficiary = _160.editBeneficiary;
    var _161 = useActions(setOpenDrawerUpload, setPdfFile, setFileName, setIdDocumentClient, setModalDocumentClient, setUrlDocumentClient, setDocName, isVidaTermino, navigate, navigateNext, STEP, id, setOpenModalBackConfirm, isPlan, isDocumentClient, workFlowId, instanceId, currentStep, nextStep, currentStepId, nextStepId, pathLocation, navigation, sendProductCode, productCode), handleNext = _161.handleNext, handlePrevious = _161.handlePrevious, onClickBack = _161.onClickBack, handleCloseBackModal = _161.handleCloseBackModal, handleBackFromModal = _161.handleBackFromModal, handleClickContextMenu = _161.handleClickContextMenu, loadingComplete = _161.loadingComplete;
    var handleSendEmail = usePaymentConfirmation(policyId, dispatch, policyConfirm).handleSendEmail;
    var filterData = useFunctions().filterData;
    var _162 = useCertificateQuote(triggerCertificate, "cotizacion", quoteId, 1, 20), responseCertificateQuote = _162.responseCertificateQuote, errorCertificateQuote = _162.errorCertificateQuote, loadingCertificateQuote = _162.loadingCertificateQuote;
    var _163 = useCatalogues(propertyTypeId), loadingCatalogues = _163.loadingCatalogues, errorCatalogues = _163.errorCatalogues, businessType = _163.businessType, typeConstruction = _163.typeConstruction, businessShift = _163.businessShift;
    var _164 = PostUploadDocuments(uploadTrigger, id ? id : quoteId, fileName, pdfFile, idDocumentClient), responseUploadDocuments = _164.responseUploadDocuments, errorUploadDocuments = _164.errorUploadDocuments, loadingUploadDocuments = _164.loadingUploadDocuments;
    var _165 = GetCatalogBeneficiary(triggerCatalog, enable, page, limit, clientId), responseGetCatalogBeneficiary = _165.responseGetCatalogBeneficiary, errorGetCatalogBeneficiary = _165.errorGetCatalogBeneficiary, loadingGetCatalogBeneficiary = _165.loadingGetCatalogBeneficiary;
    var _166 = GetCatalogInsurance(triggerCatalogInsurance, enable, page, limit, clientId, planIdForCatalog), responseGetCatalogInsurance = _166.responseGetCatalogInsurance, errorGetCatalogInsurance = _166.errorGetCatalogInsurance, loadingGetCatalogInsurance = _166.loadingGetCatalogInsurance;
    var _167 = GetPersonByDocument(trigger, document), responsePersonByDocument = _167.responsePersonByDocument, errorPersonByDocument = _167.errorPersonByDocument, loadingPersonByDocument = _167.loadingPersonByDocument;
    var _168 = GetPaymentMode(triggerPaymentMode, projectId || idProject || ""), responsePaymentMode = _168.responsePaymentMode, errorPaymentMode = _168.errorPaymentMode, loadingPaymentMode = _168.loadingPaymentMode;
    var onSameDirection = function (checked, data) {
        var _a;
        if (data === "sameAddress") {
            if (checked === true) {
                var addressFromQuote_1 = ((_a = responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.address1) || "";
                setDataFormBusiness(function (prev) { return ({
                    Province: provinceId,
                    Town: townId,
                    Sector: sectorId,
                    propertyAddress: addressFromQuote_1,
                }); });
            }
            else {
                setDataFormBusiness(function (prev) { return ({
                    Province: "",
                    Town: "",
                    Sector: "",
                    propertyAddress: "",
                }); });
            }
        }
    };
    var _169 = useStartWokFlow(triggerStart, workFlow !== null && workFlow !== void 0 ? workFlow : "", function () { return setTriggerStart(false); }), loadingStartWorkFlow = _169.loadingStartWorkFlow, responseStartWorkFlow = _169.responseStartWorkFlow, errorStartWorkflow = _169.errorStartWorkflow;
    useErrorHandling({
        errorPersonByDocument: errorPersonByDocument,
        errorOneQuote: errorOneQuote,
        errorInsured: errorInsured,
        errorCatalogGender: errorCatalogGender,
        errorCountries: errorCountries,
        errorRegion: errorRegion,
        errorUpdateQuote: errorUpdateQuote,
        errorPlan: errorPlan,
        errorBeneficiary: errorBeneficiary,
        errorIdentificationType: errorIdentificationType,
        errorUpdatePerson: errorUpdatePerson,
        errorPatchBeneficiary: errorPatchBeneficiary,
        errorPatchInsured: errorPatchInsured,
        errorBenefit: errorBenefit,
        errorPostInsured: errorPostInsured,
        errorPlans: errorPlans,
        errorUploadDocuments: errorUploadDocuments,
        errorPaymentMode: errorPaymentMode,
        errorCertificateQuote: errorCertificateQuote,
        errorStartWorkflow: errorStartWorkflow,
        errorPolicyConfirm: responsePolicyConfirmError,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        var _a;
        dispatch(pageActionFlagsClearData());
        // Remove summary from localStorage if coming from insurancePoliciesSummary
        if (idProject) {
            localStorage.removeItem("summary");
        }
        setProjectTrigger(true);
        if (idProject || projectId) {
            dispatch(projectOne({
                id: idProject ? idProject : projectId,
            }));
        }
        setTriggerCatalog(true);
        setTriggerPaymentMode(true);
        getActionFlags();
        if (!responseIdentificationType) {
            dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        }
        if (!responseCountries) {
            dispatch(countries({ enable: enable, page: page, limit: limit }));
        }
        if (!(responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data)) {
            dispatch(catalogGender({ enable: enable, page: page, limit: limit }));
        }
        //Get Quote //
        var quoteIdLs = quoteIdLS;
        if (id !== undefined) {
            dispatch(quoteClearData());
            setCanEdit(isQuoteType);
            if (!isQuoteType) {
                setCanEditLocation(true);
                setCanEditContact(true);
            }
            //Get the quote by id
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteIdLs);
        }
        callGetInsuredBeneficiary((_a = id !== null && id !== void 0 ? id : quoteIdLs) !== null && _a !== void 0 ? _a : "");
        // Note: callDispatchPlan moved to useEffect that waits for responseOneQuote
    }, []);
    useEffect(function () {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
    }, [id]);
    // startFlow
    useEffect(function () {
        if (id !== undefined || isQuoteType) {
            setTriggerStart(true);
        }
    }, [workFlow]);
    useEffect(function () {
        var _a, _b;
        if (responseStartWorkFlow) {
            var nextStepId_1 = ((_a = responseStartWorkFlow.nextSteps[0]) === null || _a === void 0 ? void 0 : _a.nextSteps[0]) || "";
            setInstanceIdR(responseStartWorkFlow.instanceId);
            setCurrentStepId((_b = responseStartWorkFlow.currentStep) === null || _b === void 0 ? void 0 : _b.id);
            setNextStepId(nextStepId_1);
            localStorage.setItem("Quote", id !== null && id !== void 0 ? id : "");
            addStepInformationToAllSteps(workFlow !== null && workFlow !== void 0 ? workFlow : "", responseStartWorkFlow.instanceId);
            // Refrescar la información de los pasos después de actualizar localStorage
            setRefreshStepsInfo(function (prev) { return prev + 1; });
            dispatch(startWorkFlowClearData());
        }
    }, [responseStartWorkFlow]);
    //end startFlow
    useEffect(function () {
        var _a, _b, _c;
        if (responsePaymentMode && responsePaymentMode.length > 0) {
            // Transform payment mode response to select format
            var paymentModeList_1 = [];
            var quotePaymentModeId_1 = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id;
            responsePaymentMode.map(function (item) {
                var _a, _b, _c, _d;
                var itemId = ((_a = item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id) || item.id;
                paymentModeList_1.push({
                    id: itemId,
                    name: ((_b = item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description) || item.description || "",
                    value: ((_c = item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code) ||
                        ((_d = item.catalogPaymentMode) === null || _d === void 0 ? void 0 : _d.id) ||
                        item.id,
                    default: quotePaymentModeId_1 ? itemId === quotePaymentModeId_1 : false,
                });
            });
            setPaymentMode(paymentModeList_1);
            // Set initial payment mode selection only if not already set and no quote data available
            if (!(paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                paymentModeList_1.length > 0 &&
                !((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogPaymentMode)) {
                setPaymentModelSelected(paymentModeList_1[0]);
                // Set initial period when payment mode is first loaded
                setPeriod(paymentModeList_1[0].name);
            }
        }
    }, [responsePaymentMode, (_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.catalogPaymentMode) === null || _o === void 0 ? void 0 : _o.id]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setRowsPassengers((((_a = responseOneQuote.data.contentMap) === null || _a === void 0 ? void 0 : _a.additionalTravelers) || []).map(function (t) {
                var birthday = t.birthday || t.Birthday || "";
                var edad = "";
                if (birthday) {
                    var birth = new Date(birthday);
                    // Handle DD/MM/YYYY format
                    if (isNaN(birth.getTime())) {
                        var parts = birthday.split("/");
                        if (parts.length === 3) {
                            birth = new Date("".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0]));
                        }
                    }
                    if (!isNaN(birth.getTime())) {
                        var today = new Date();
                        var age = today.getFullYear() - birth.getFullYear();
                        var m = today.getMonth() - birth.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birth.getDate()))
                            age--;
                        edad = String(age);
                    }
                }
                return __assign(__assign({}, t), { birthday: birthday, edad: edad });
            }));
            var combustionMap = {
                GASOLINE: "Gasolina",
                DIESEL: "Diesel",
                ELECTRIC: "Eléctrico",
                GAS: "Gas",
            };
            var combustionType = (_b = responseOneQuote.data.contentMap) === null || _b === void 0 ? void 0 : _b.combustion;
            var carCombustion = combustionMap[combustionType] || "";
            var price = parsePrice(((_c = responseOneQuote.data.contentMap) === null || _c === void 0 ? void 0 : _c.deductibleTypeId) || 0);
            var newPrice = formatNumberCustom(price || 0);
            var car = {
                id: 1,
                brand: (_e = (_d = responseOneQuote.data.contentMap) === null || _d === void 0 ? void 0 : _d.brand) === null || _e === void 0 ? void 0 : _e.name,
                model: (_g = (_f = responseOneQuote.data.contentMap) === null || _f === void 0 ? void 0 : _f.model) === null || _g === void 0 ? void 0 : _g.name,
                fueltype: carCombustion,
                color: (_j = (_h = responseOneQuote.data.contentMap) === null || _h === void 0 ? void 0 : _h.colors) === null || _j === void 0 ? void 0 : _j.name,
                price: "RD$ ".concat(newPrice),
                cylinders: (_k = responseOneQuote.data.contentMap) === null || _k === void 0 ? void 0 : _k.cylinders,
                plate: (_l = responseOneQuote.data.contentMap) === null || _l === void 0 ? void 0 : _l.plate,
            };
            var vehicleDet = [];
            vehicleDet.push(car);
            setListVehicles(vehicleDet);
        }
    }, [responseOneQuote]);
    // Llenar datos de propiedad inmobiliaria
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseOneQuote && ((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap)) {
            var contentMap_1 = responseOneQuote.data.contentMap;
            setPropertyTypeId(contentMap_1.propertyTypeId || "");
            setDamageBackup(formatToTwoDecimals(contentMap_1.damageBackup));
            setInsuredProperty(formatToTwoDecimals(contentMap_1.insuredProperty));
            setDataFormBusiness({
                ownerName: contentMap_1.ownerName,
                ownerIdNumber: contentMap_1.ownerIdNumber,
                propertyTypeId: contentMap_1.propertyTypeId,
                businessShift: contentMap_1.businessShift,
                sameAddress: contentMap_1.sameAddress,
                Province: contentMap_1.province,
                Town: contentMap_1.town,
                Sector: contentMap_1.sector,
                typeConstruction: contentMap_1.typeConstruction,
                propertyAddress: contentMap_1.propertyAddress,
                coverageNotes: contentMap_1.coverageNotes,
                typeProperty: contentMap_1.typeProperty,
                buildingValue: formatToTwoDecimals(contentMap_1.buildingValue),
                merchandiseValue: formatToTwoDecimals(contentMap_1.merchandiseValue),
                furnitureValue: formatToTwoDecimals(contentMap_1.furnitureValue),
                totalInsuredValue: formatToTwoDecimals(contentMap_1.transitValue),
            });
            if (contentMap_1.ownerName ||
                contentMap_1.businessShift ||
                contentMap_1.typeConstruction ||
                contentMap_1.propertyTypeId ||
                contentMap_1.address ||
                contentMap_1.constructionTypeName) {
                var businessTypeName = ((_b = businessType.find(function (item) { return item.id === contentMap_1.propertyTypeId; })) === null || _b === void 0 ? void 0 : _b.name) ||
                    contentMap_1.propertyTypeId ||
                    "";
                var businessShiftName = ((_c = businessShift.find(function (item) { return item.id === contentMap_1.businessShift; })) === null || _c === void 0 ? void 0 : _c.name) ||
                    contentMap_1.businessShift ||
                    "";
                var typeConstructionName = ((_d = typeConstruction.find(function (item) { return item.id === contentMap_1.typeConstruction; })) === null || _d === void 0 ? void 0 : _d.name) ||
                    contentMap_1.typeConstruction ||
                    "";
                var propertyData = {
                    id: 1,
                    ownerName: contentMap_1.ownerName || "",
                    propertyTypeId: businessTypeName,
                    businessShift: businessShiftName,
                    typeConstruction: typeConstructionName,
                    typeConstructionName: contentMap_1.constructionTypeName || "",
                    propertyAddress: contentMap_1.address || "",
                };
                setRowsProperties([propertyData]);
            }
        }
    }, [responseOneQuote, businessType, businessShift, typeConstruction]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseCertificateQuote && ((_a = responseCertificateQuote.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var urlC = (_b = responseCertificateQuote.data[0]) === null || _b === void 0 ? void 0 : _b.url;
            if (urlC) {
                setUrlDocument(urlC);
                setNameDocument((_c = responseCertificateQuote.data[0]) === null || _c === void 0 ? void 0 : _c.title);
                setopenModalPdfViewer(true);
            }
            setTriggerCertificate(false);
            dispatch(certificateQuoteClearData());
        }
        else if (responseCertificateQuote &&
            ((_d = responseCertificateQuote.data) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            setTriggerCertificate(false);
            showToastSuccessMessage("No se encontro ningun documento adjunto.", typeAlert.warning, setSeeToast);
            dispatch(certificateQuoteClearData());
        }
    }, [responseCertificateQuote]);
    // determina con que servicio iniciar el formulario de negocio
    useEffect(function () {
        if (planName) {
            var isCommerceValue_1 = planName.toLowerCase().includes("comercio");
            setIsCommerce(isCommerceValue_1);
            setDataFormBusiness(function (prev) { return (__assign(__assign({}, prev), { propertyTypeId: isCommerceValue_1 ? "1" : "2" })); });
        }
    }, [planName]);
    useEffect(function () {
        // Solo setear el país una vez cuando listCountries se cargue por primera vez
        if (listCountries.length > 0 && !countryInitializedRef.current) {
            var countryId_1 = getLogin().countryId || "";
            if (countryId_1) {
                setDataFormInsuranceSp(function (prev) { return (__assign(__assign({}, prev), { country: countryId_1 })); });
                countryInitializedRef.current = true;
            }
        }
    }, [listCountries]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setProvinceId((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.province) === null || _b === void 0 ? void 0 : _b.id);
            setTowId((_d = (_c = responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.municipality) === null || _d === void 0 ? void 0 : _d.id);
            setSectorId((_f = (_e = responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.district) === null || _f === void 0 ? void 0 : _f.id);
            setPlanCode(((_g = responseOneQuote.data) === null || _g === void 0 ? void 0 : _g.planId.code) || "");
            setProductCode(((_j = (_h = responseOneQuote.data) === null || _h === void 0 ? void 0 : _h.productId) === null || _j === void 0 ? void 0 : _j.code) || "");
            setPersonQuoteId((_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _k === void 0 ? void 0 : _k.personId);
            setQuoteId((_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _l === void 0 ? void 0 : _l.id);
            setPlanId((_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.planId) === null || _o === void 0 ? void 0 : _o.id);
            setCoverTypeId((_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.coverType) === null || _q === void 0 ? void 0 : _q.id);
            setTriggerCatalogInsurance(true);
            setCampaignId((_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.campaignId) === null || _s === void 0 ? void 0 : _s.id);
            setCatalogPaymentMode((_u = (_t = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _t === void 0 ? void 0 : _t.catalogPaymentMode) === null || _u === void 0 ? void 0 : _u.id);
            setEmail((_w = (responseOneQuote && ((_v = responseOneQuote.data) === null || _v === void 0 ? void 0 : _v.email))) !== null && _w !== void 0 ? _w : "");
            var currentStatusQuote = (_y = (_x = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _x === void 0 ? void 0 : _x.catalogStatusQuote) === null || _y === void 0 ? void 0 : _y.description;
            setPlan({
                id: (_0 = (_z = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _z === void 0 ? void 0 : _z.planId) === null || _0 === void 0 ? void 0 : _0.id,
                name: (_2 = (_1 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _1 === void 0 ? void 0 : _1.planId) === null || _2 === void 0 ? void 0 : _2.name,
            });
            var quoteStatus_1 = currentStatusQuote === null || currentStatusQuote === void 0 ? void 0 : currentStatusQuote.toLowerCase();
            // Logica para mostrar o no los ducumentos de descarga
            var shouldShowDownloads = (function () {
                var _a;
                //If quote status Deny List exist evaulate list first
                if (downloadsStatusDenyList.length > 0 &&
                    !downloadsStatusDenyList.includes(quoteStatus_1)) {
                    // Prevent duplicate loading:
                    // - If id exists → skip
                    // - If id doesn't exist but there is a deny list then setCertificates
                    if (!id) {
                        var certs = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.certificates;
                        //Get the certificates
                        if (certs.length > 0) {
                            certs = certs.map(function (c, id) {
                                return {
                                    id: c.id,
                                    name: c.title,
                                    url: c.url,
                                };
                            });
                        }
                        setCertificates(certs);
                    }
                    return true;
                }
                // en el flujo de venta nuca se muestra
                if (id === undefined || isQuoteType)
                    return false;
                if (downloadsStatusDenyList.length > 0 &&
                    !downloadsStatusDenyList.includes(quoteStatus_1)) {
                    return true;
                }
                // Emitida siempre se muestra
                if (quoteStatus_1 === "emitida")
                    return true;
                // Cotizada no se muestra
                if (quoteStatus_1 === "cotizada")
                    return false;
                // Cancelada solo es es acap no se muestra
                if (quoteStatus_1 === "cancelada")
                    return !isAcapCompany;
                return false;
            })();
            //Set show payment tab by quote status if actionflag exist
            setHideTabPaymentInfo(!(isQuote === "false"));
            if (isThereTabPaymentStatusAllowList) {
                if (showTabPaymentStatusAllowList.includes(quoteStatus_1)) {
                    setHideTabPaymentInfo(false);
                }
                else {
                    setHideTabPaymentInfo(true);
                }
            }
            setShowDownloads(shouldShowDownloads);
            setPolicyId((_4 = (_3 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _3 === void 0 ? void 0 : _3.policyId) === null || _4 === void 0 ? void 0 : _4.id);
            setPolicyStatus((_8 = (_7 = (_6 = (_5 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _5 === void 0 ? void 0 : _5.policyId) === null || _6 === void 0 ? void 0 : _6.policyStatus) === null || _7 === void 0 ? void 0 : _7.description) !== null && _8 !== void 0 ? _8 : "");
            var pmData = (_9 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _9 === void 0 ? void 0 : _9.customerAccount;
            if (pmData) {
                var accountType = (_11 = (_10 = pmData === null || pmData === void 0 ? void 0 : pmData.accountType) === null || _10 === void 0 ? void 0 : _10.description) !== null && _11 !== void 0 ? _11 : "";
                setPaymentMethodCardData([
                    { name: "Tipo de cuenta", type: "label", label: accountType },
                    {
                        name: "Número de tarjeta / cuenta",
                        type: "label",
                        label: (_12 = pmData.accountNumber) !== null && _12 !== void 0 ? _12 : "",
                        showChangeButton: true,
                    },
                ]);
            }
            // Update paymentModelSelected with the catalogPaymentMode from quote
            if ((_13 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _13 === void 0 ? void 0 : _13.catalogPaymentMode) {
                var selectedPaymentMode = {
                    id: responseOneQuote.data.catalogPaymentMode.id,
                    name: responseOneQuote.data.catalogPaymentMode.description,
                    value: responseOneQuote.data.catalogPaymentMode.code ||
                        responseOneQuote.data.catalogPaymentMode.id,
                    label: responseOneQuote.data.catalogPaymentMode.description,
                };
                setPaymentModelSelected(selectedPaymentMode);
                // Set period from quote data
                setPeriod(responseOneQuote.data.catalogPaymentMode.description);
                // Update paymentMode array to mark the correct option as default
                if (paymentMode.length > 0) {
                    var updatedPaymentMode = paymentMode.map(function (mode) { return (__assign(__assign({}, mode), { default: mode.id === responseOneQuote.data.catalogPaymentMode.id })); });
                    setPaymentMode(updatedPaymentMode);
                }
            }
            setCatalogStatusQuote((_15 = (_14 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _14 === void 0 ? void 0 : _14.catalogStatusQuote) === null || _15 === void 0 ? void 0 : _15.id);
            var statusDescription = (_18 = (_17 = (_16 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _16 === void 0 ? void 0 : _16.catalogStatusQuote) === null || _17 === void 0 ? void 0 : _17.description) === null || _18 === void 0 ? void 0 : _18.toLowerCase();
            setAddAppointmentAction(statusDescription !== "ganada");
            setBranchId((_19 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _19 === void 0 ? void 0 : _19.branch);
            setPlanName((_21 = (_20 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _20 === void 0 ? void 0 : _20.planId) === null || _21 === void 0 ? void 0 : _21.name);
            // getInsuredBeneficiary();
            var gender = listGenders.find(function (g) { var _a, _b; return g.id === ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogGender) === null || _b === void 0 ? void 0 : _b.id); });
            var HideMarriedName = (gender === null || gender === void 0 ? void 0 : gender.name) === "Femenino" ? false : true;
            setHideMarriedName(HideMarriedName);
            /*date = formattedDate(date);*/
            //Province
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level1,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //Municipality
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level2,
                parentRegionId: (_23 = (_22 = responseOneQuote.data) === null || _22 === void 0 ? void 0 : _22.municipality) === null || _23 === void 0 ? void 0 : _23.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //District
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level3,
                parentRegionId: (_25 = (_24 = responseOneQuote.data) === null || _24 === void 0 ? void 0 : _24.district) === null || _25 === void 0 ? void 0 : _25.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            var status = (_27 = (_26 = responseOneQuote.data) === null || _26 === void 0 ? void 0 : _26.catalogStatusQuote) === null || _27 === void 0 ? void 0 : _27.description;
            if (status == "Cancelada") {
                status = "Fecha de cancelación";
            }
            else if (status == "Emitida") {
                status = "Fecha de emisión";
            }
            else if (status == "Expirada") {
                status = "Fecha de expiración";
            }
            else {
                status = "Fecha de cotización";
            }
            var date = ((_29 = (_28 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _28 === void 0 ? void 0 : _28.policyId) === null || _29 === void 0 ? void 0 : _29.effectiveFrom) ||
                ((_30 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _30 === void 0 ? void 0 : _30.creationDate);
            var nextYearDate = undefined;
            var originalDate = void 0;
            if (date) {
                var originalDate_1 = new Date(date);
                originalDate_1.setFullYear(originalDate_1.getFullYear() + 1);
                nextYearDate = formattedDate(originalDate_1.toISOString());
                nextYearDate = originalDate_1.toISOString();
            }
            setDataForm({
                DocumentNumber: formatDocument(responseOneQuote && ((_31 = responseOneQuote.data) === null || _31 === void 0 ? void 0 : _31.numberId)),
                IdType: ((_33 = (_32 = responseOneQuote.data) === null || _32 === void 0 ? void 0 : _32.identificationTypeId) === null || _33 === void 0 ? void 0 : _33.id)
                    ? (_35 = (_34 = responseOneQuote.data) === null || _34 === void 0 ? void 0 : _34.identificationTypeId) === null || _35 === void 0 ? void 0 : _35.id
                    : "",
                Type: responseOneQuote &&
                    ((_37 = (_36 = responseOneQuote.data) === null || _36 === void 0 ? void 0 : _36.identificationTypeId) === null || _37 === void 0 ? void 0 : _37.description),
                QuoteNumber: ((_38 = responseOneQuote.data) === null || _38 === void 0 ? void 0 : _38.policyId)
                    ? (_39 = responseOneQuote.data) === null || _39 === void 0 ? void 0 : _39.policyId.code
                    : responseOneQuote && ((_40 = responseOneQuote.data) === null || _40 === void 0 ? void 0 : _40.code),
                Name: responseOneQuote && ((_41 = responseOneQuote.data) === null || _41 === void 0 ? void 0 : _41.firstNameA),
                SecondName: responseOneQuote && ((_42 = responseOneQuote.data) === null || _42 === void 0 ? void 0 : _42.firstNameB),
                FirstLastName: responseOneQuote && ((_43 = responseOneQuote.data) === null || _43 === void 0 ? void 0 : _43.lastNameA),
                SecondLastName: responseOneQuote && ((_44 = responseOneQuote.data) === null || _44 === void 0 ? void 0 : _44.lastNameB),
                MarriedSurName: responseOneQuote && ((_45 = responseOneQuote.data) === null || _45 === void 0 ? void 0 : _45.marriedName),
                Birthday: responseOneQuote && ((_46 = responseOneQuote.data) === null || _46 === void 0 ? void 0 : _46.dob),
                Address1: responseOneQuote && ((_47 = responseOneQuote.data) === null || _47 === void 0 ? void 0 : _47.address1),
                Address2: responseOneQuote && ((_48 = responseOneQuote.data) === null || _48 === void 0 ? void 0 : _48.address2),
                PhoneOffice: responseOneQuote && formatPhoneNumber((_49 = responseOneQuote.data) === null || _49 === void 0 ? void 0 : _49.phone2),
                PhoneHome: responseOneQuote && formatPhoneNumber((_50 = responseOneQuote.data) === null || _50 === void 0 ? void 0 : _50.phone1),
                PhoneNumber: responseOneQuote && formatPhoneNumber((_51 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _51 === void 0 ? void 0 : _51.phone3),
                Email: responseOneQuote && ((_52 = responseOneQuote.data) === null || _52 === void 0 ? void 0 : _52.email),
                QuoteStatusName: responseOneQuote &&
                    ((_54 = (_53 = responseOneQuote.data) === null || _53 === void 0 ? void 0 : _53.catalogStatusQuote) === null || _54 === void 0 ? void 0 : _54.description),
                QuoteDate: date,
                effectiveDate: responseOneQuote && ((_55 = responseOneQuote.data) === null || _55 === void 0 ? void 0 : _55.policyId)
                    ? nextYearDate
                    : "",
                PlanTypeName: responseOneQuote && ((_57 = (_56 = responseOneQuote.data) === null || _56 === void 0 ? void 0 : _56.planId) === null || _57 === void 0 ? void 0 : _57.name),
                CampaignName: responseOneQuote && ((_59 = (_58 = responseOneQuote.data) === null || _58 === void 0 ? void 0 : _58.campaignId) === null || _59 === void 0 ? void 0 : _59.name),
                IdTypeName: responseOneQuote &&
                    ((_61 = (_60 = responseOneQuote.data) === null || _60 === void 0 ? void 0 : _60.identificationTypeId) === null || _61 === void 0 ? void 0 : _61.description),
                Gender: responseOneQuote && ((_63 = (_62 = responseOneQuote.data) === null || _62 === void 0 ? void 0 : _62.catalogGender) === null || _63 === void 0 ? void 0 : _63.id),
                Country: responseOneQuote && ((_65 = (_64 = responseOneQuote.data) === null || _64 === void 0 ? void 0 : _64.nationality) === null || _65 === void 0 ? void 0 : _65.id),
                CountryName: responseOneQuote && ((_67 = (_66 = responseOneQuote.data) === null || _66 === void 0 ? void 0 : _66.nationality) === null || _67 === void 0 ? void 0 : _67.name),
                Province: responseOneQuote && ((_69 = (_68 = responseOneQuote.data) === null || _68 === void 0 ? void 0 : _68.province) === null || _69 === void 0 ? void 0 : _69.id),
                ProvinceName: responseOneQuote && ((_71 = (_70 = responseOneQuote.data) === null || _70 === void 0 ? void 0 : _70.province) === null || _71 === void 0 ? void 0 : _71.name),
                TownName: responseOneQuote && ((_73 = (_72 = responseOneQuote.data) === null || _72 === void 0 ? void 0 : _72.municipality) === null || _73 === void 0 ? void 0 : _73.name),
                Town: responseOneQuote && ((_75 = (_74 = responseOneQuote.data) === null || _74 === void 0 ? void 0 : _74.municipality) === null || _75 === void 0 ? void 0 : _75.id),
                Sector: responseOneQuote && ((_77 = (_76 = responseOneQuote.data) === null || _76 === void 0 ? void 0 : _76.district) === null || _77 === void 0 ? void 0 : _77.id),
                SectorName: responseOneQuote && ((_79 = (_78 = responseOneQuote.data) === null || _78 === void 0 ? void 0 : _78.district) === null || _79 === void 0 ? void 0 : _79.name),
                PostalCode: responseOneQuote && ((_80 = responseOneQuote.data) === null || _80 === void 0 ? void 0 : _80.zip),
            });
            //setFormVehicle
            setIdQuoteVehicle((_82 = (_81 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _81 === void 0 ? void 0 : _81.contentMap) === null || _82 === void 0 ? void 0 : _82.idquoteVehicle);
            setProductId((_84 = (_83 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _83 === void 0 ? void 0 : _83.productId) === null || _84 === void 0 ? void 0 : _84.id);
            var carConditionName = void 0;
            switch ((_86 = (_85 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _85 === void 0 ? void 0 : _85.contentMap) === null || _86 === void 0 ? void 0 : _86.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            if ((_87 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _87 === void 0 ? void 0 : _87.profileDocuments) {
                var isCancelledQuote_1 = ((_90 = (_89 = (_88 = responseOneQuote.data) === null || _88 === void 0 ? void 0 : _88.catalogStatusQuote) === null || _89 === void 0 ? void 0 : _89.description) === null || _90 === void 0 ? void 0 : _90.toLowerCase()) ===
                    "cancelada";
                var pendingCount = responseOneQuote.data.profileDocuments.filter(function (doc) { return (doc === null || doc === void 0 ? void 0 : doc.status) === "PENDING" && (doc === null || doc === void 0 ? void 0 : doc.required) === true; }).length;
                setCountBadge(pendingCount);
                var dataRows = (_92 = (_91 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _91 === void 0 ? void 0 : _91.profileDocuments) === null || _92 === void 0 ? void 0 : _92.slice().sort(function (a, b) { return (b.required ? 1 : 0) - (a.required ? 1 : 0); }).filter(function (item) {
                    var _a;
                    if (!isCancelledQuote_1) {
                        return !((_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("cancelaci"));
                    }
                    return true;
                }).map(function (item) {
                    var _a;
                    return ({
                        id: item.id,
                        docType: item.name,
                        mandatory: item.required === true ? "Requerido" : "Opcional",
                        state: (function () {
                            switch (item.status) {
                                case "PENDING":
                                    return "Pendiente";
                                case "READY":
                                    return "Listo";
                            }
                        })(),
                        required: item.required,
                        date: "",
                        user: "",
                        documentClientUrl: ((_a = item.document) === null || _a === void 0 ? void 0 : _a.path) || "",
                    });
                });
                setProfileDocumentsRows(dataRows);
            }
            var fuelTypeName = void 0;
            switch ((_94 = (_93 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _93 === void 0 ? void 0 : _93.contentMap) === null || _94 === void 0 ? void 0 : _94.combustion) {
                case "GAS":
                    fuelTypeName = "Gas";
                    break;
                case "ELECTRIC":
                    fuelTypeName = "Eléctrico";
                    break;
                case "DIESEL":
                    fuelTypeName = "Diesel";
                    break;
                case "GASOLINE":
                    fuelTypeName = "Gasolina";
                    break;
            }
            var countChassis = ((_96 = (_95 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _95 === void 0 ? void 0 : _95.contentMap) === null || _96 === void 0 ? void 0 : _96.chassisNumber) || "";
            var isChassisValid = (countChassis === null || countChassis === void 0 ? void 0 : countChassis.length) !== 17;
            setDataFormVehicle({
                carDetails: [
                    {
                        brand: {
                            id: (_99 = (_98 = (_97 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _97 === void 0 ? void 0 : _97.contentMap) === null || _98 === void 0 ? void 0 : _98.brand) === null || _99 === void 0 ? void 0 : _99.id,
                            name: (_102 = (_101 = (_100 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _100 === void 0 ? void 0 : _100.contentMap) === null || _101 === void 0 ? void 0 : _101.brand) === null || _102 === void 0 ? void 0 : _102.name,
                        },
                        model: {
                            id: (_105 = (_104 = (_103 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _103 === void 0 ? void 0 : _103.contentMap) === null || _104 === void 0 ? void 0 : _104.model) === null || _105 === void 0 ? void 0 : _105.id,
                            name: (_108 = (_107 = (_106 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _106 === void 0 ? void 0 : _106.contentMap) === null || _107 === void 0 ? void 0 : _107.model) === null || _108 === void 0 ? void 0 : _108.name,
                        },
                        version: {
                            id: (_111 = (_110 = (_109 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _109 === void 0 ? void 0 : _109.contentMap) === null || _110 === void 0 ? void 0 : _110.version) === null || _111 === void 0 ? void 0 : _111.id,
                            name: (_114 = (_113 = (_112 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _112 === void 0 ? void 0 : _112.contentMap) === null || _113 === void 0 ? void 0 : _113.version) === null || _114 === void 0 ? void 0 : _114.name,
                        },
                        class: {
                            id: (_117 = (_116 = (_115 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _115 === void 0 ? void 0 : _115.contentMap) === null || _116 === void 0 ? void 0 : _116.class) === null || _117 === void 0 ? void 0 : _117.id,
                            name: (_120 = (_119 = (_118 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _118 === void 0 ? void 0 : _118.contentMap) === null || _119 === void 0 ? void 0 : _119.class) === null || _120 === void 0 ? void 0 : _120.name,
                        },
                        type: {
                            id: (_123 = (_122 = (_121 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _121 === void 0 ? void 0 : _121.contentMap) === null || _122 === void 0 ? void 0 : _122.type) === null || _123 === void 0 ? void 0 : _123.id,
                            name: (_126 = (_125 = (_124 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _124 === void 0 ? void 0 : _124.contentMap) === null || _125 === void 0 ? void 0 : _125.type) === null || _126 === void 0 ? void 0 : _126.name,
                        },
                        weight: (_128 = (_127 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _127 === void 0 ? void 0 : _127.contentMap) === null || _128 === void 0 ? void 0 : _128.weight,
                        tonnage: (_130 = (_129 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _129 === void 0 ? void 0 : _129.contentMap) === null || _130 === void 0 ? void 0 : _130.tonnage,
                        passengerCant: (_132 = (_131 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _131 === void 0 ? void 0 : _131.contentMap) === null || _132 === void 0 ? void 0 : _132.passengerCant,
                    },
                ],
                year: (_134 = (_133 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _133 === void 0 ? void 0 : _133.contentMap) === null || _134 === void 0 ? void 0 : _134.year,
                carColor: [
                    {
                        id: (_137 = (_136 = (_135 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _135 === void 0 ? void 0 : _135.contentMap) === null || _136 === void 0 ? void 0 : _136.colors) === null || _137 === void 0 ? void 0 : _137.id,
                        name: (_140 = (_139 = (_138 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _138 === void 0 ? void 0 : _138.contentMap) === null || _139 === void 0 ? void 0 : _139.colors) === null || _140 === void 0 ? void 0 : _140.name,
                    },
                ],
                chassisNumber: (_142 = (_141 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _141 === void 0 ? void 0 : _141.contentMap) === null || _142 === void 0 ? void 0 : _142.chassisNumber,
                shortChassis: isChassisValid,
                price: (_144 = (_143 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _143 === void 0 ? void 0 : _143.contentMap) === null || _144 === void 0 ? void 0 : _144.deductibleTypeId,
                numberCylinders: [
                    {
                        id: (_146 = (_145 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _145 === void 0 ? void 0 : _145.contentMap) === null || _146 === void 0 ? void 0 : _146.cylinders,
                        name: (_148 = (_147 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _147 === void 0 ? void 0 : _147.contentMap) === null || _148 === void 0 ? void 0 : _148.cylinders,
                    },
                ],
                fuelType: [
                    {
                        id: (_150 = (_149 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _149 === void 0 ? void 0 : _149.contentMap) === null || _150 === void 0 ? void 0 : _150.combustion,
                        name: fuelTypeName,
                    },
                ],
                registrationNumber: (_152 = (_151 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _151 === void 0 ? void 0 : _151.contentMap) === null || _152 === void 0 ? void 0 : _152.plate,
                carCondition: [
                    {
                        id: (_154 = (_153 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _153 === void 0 ? void 0 : _153.contentMap) === null || _154 === void 0 ? void 0 : _154.condition,
                        name: carConditionName,
                    },
                ],
            });
            //EndFormVehicle
            //setStatementRows
            if (responseOneQuote.data.billing) {
                var dataRows = (_156 = (_155 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _155 === void 0 ? void 0 : _155.billing) === null || _156 === void 0 ? void 0 : _156.map(function (item) { return ({
                    accountName: item.account,
                    amount: "RD$ ".concat(item.amount),
                    paymentDate: newFormattedDate(item.paymentDate),
                    dateExpire: newFormattedDate(item.dateExpire),
                    datePaid: newFormattedDate(item.datePaid),
                    state: (function () {
                        switch (item.statusBilling) {
                            case "GENERATED":
                                return "Generado";
                            case "EMMITED":
                                return "Emitido";
                            case "PAID":
                                return "Pagado";
                            case "CANCELLED":
                                return "Cancelado";
                        }
                    })(),
                }); });
                setStatementRows(dataRows);
            }
            // EndSetStatmentRows
            // if (id) {
            // setPrime(responseOneQuote?.data?.lastPrice?.amount);
            setPrime(((_158 = (_157 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _157 === void 0 ? void 0 : _157.lastPrice) === null || _158 === void 0 ? void 0 : _158.amount)
                ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                : "0.00");
            callDispatchPageActionFlags((_160 = (_159 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _159 === void 0 ? void 0 : _159.planId) === null || _160 === void 0 ? void 0 : _160.projectId);
            // Update projectId from the quote response
            if ((_162 = (_161 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _161 === void 0 ? void 0 : _161.planId) === null || _162 === void 0 ? void 0 : _162.projectId) {
                setProjectId(responseOneQuote.data.planId.projectId);
            }
            var campaignData = {
                id: (_164 = (_163 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _163 === void 0 ? void 0 : _163.campaignId) === null || _164 === void 0 ? void 0 : _164.id,
                name: (_166 = (_165 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _165 === void 0 ? void 0 : _165.campaignId) === null || _166 === void 0 ? void 0 : _166.name,
                value: (_168 = (_167 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _167 === void 0 ? void 0 : _167.campaignId) === null || _168 === void 0 ? void 0 : _168.id,
            };
            setCampaignSelected(campaignData);
            if (id) {
                if (isQuote === "false") {
                    setBreadCrumbs([]);
                }
                else {
                    setBreadCrumbs(stepProgress(STEP, true));
                }
                var certs = (_169 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _169 === void 0 ? void 0 : _169.certificates;
                //Get the certificates
                if (certs.length > 0) {
                    certs = certs.map(function (c, id) {
                        return {
                            id: c.id,
                            name: c.title,
                            url: c.url,
                            status: c.status,
                        };
                    });
                }
                setCertificates(certs);
                //Get the additional payment info
                if ((responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) && isQuote && isQuote === "false") {
                    var additionalInfo = [];
                    var data = responseOneQuote.data;
                    var lastPrice = data.lastPrice, customerAccount = data.customerAccount, catalogPaymentMode_1 = data.catalogPaymentMode, id_1 = data.id;
                    var amount = (_170 = lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.amount) !== null && _170 !== void 0 ? _170 : "0.00";
                    var currencySymbol = (lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.currencySymbol) || "";
                    var formattedAmount = formatToTwoDecimals(amount);
                    additionalInfo.push({
                        id: id_1,
                        accountName: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountName,
                        accountNumber: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountNumber,
                        accountType: (_171 = customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountType) === null || _171 === void 0 ? void 0 : _171.description,
                        paymentMode: catalogPaymentMode_1 === null || catalogPaymentMode_1 === void 0 ? void 0 : catalogPaymentMode_1.description,
                        prime: "".concat(currencySymbol, " ").concat(formattedAmount),
                        lastDigits: "N/A",
                    });
                    setRows2(additionalInfo);
                }
            }
            else {
                setRows2([
                    {
                        id: "1",
                        accountName: "N/A",
                        accountNumber: "N/A",
                        accountType: "N/A",
                        paymentMode: "N/A",
                        prime: "N/A",
                        lastDigits: "N/A",
                    },
                ]);
            }
            /*Adiciona al resumen la informacion de vehiculos*/
            switch ((_173 = (_172 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _172 === void 0 ? void 0 : _172.contentMap) === null || _173 === void 0 ? void 0 : _173.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            var afy_currency = (_174 = actionFlags.find(function (x) { return x.name === "afy-plan-currency"; })) === null || _174 === void 0 ? void 0 : _174.value;
            var price = ((_176 = (_175 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _175 === void 0 ? void 0 : _175.lastPrice) === null || _176 === void 0 ? void 0 : _176.currencySymbol) &&
                ((_178 = (_177 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _177 === void 0 ? void 0 : _177.lastPrice) === null || _178 === void 0 ? void 0 : _178.amount)
                ? "".concat(afy_currency !== null && afy_currency !== void 0 ? afy_currency : (_180 = (_179 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _179 === void 0 ? void 0 : _179.lastPrice) === null || _180 === void 0 ? void 0 : _180.currencySymbol, " ").concat(formatToTwoDecimals((_182 = (_181 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _181 === void 0 ? void 0 : _181.lastPrice) === null || _182 === void 0 ? void 0 : _182.amount))
                : "RD$ 0.00";
            var baseFilters = [
                {
                    name: "Producto",
                    type: "label",
                    label: (_185 = (_184 = (_183 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _183 === void 0 ? void 0 : _183.productId) === null || _184 === void 0 ? void 0 : _184.description) !== null && _185 !== void 0 ? _185 : "",
                },
                {
                    name: "Plan",
                    type: "label",
                    label: (_188 = (_187 = (_186 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _186 === void 0 ? void 0 : _186.planId) === null || _187 === void 0 ? void 0 : _187.name) !== null && _188 !== void 0 ? _188 : "",
                    showChangeButton: !hideChangeButton,
                },
                {
                    name: "Modalidad de Pago",
                    type: "label",
                    label: (function () {
                        var _a, _b, _c, _d, _e;
                        var desc = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
                        if (desc)
                            return desc;
                        var freq = (_d = (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.additionalDataMap) === null || _d === void 0 ? void 0 : _d.paymentFrequency;
                        if (!freq)
                            return "";
                        var freqMap = {
                            ANNUAL: "Anual",
                            MONTHLY: "Mensual",
                            QUARTERLY: "Trimestral",
                            SEMIANNUAL: "Semestral",
                        };
                        return (_e = freqMap[freq]) !== null && _e !== void 0 ? _e : freq;
                    })(),
                    showChangeButton: !hideChangeButton,
                },
                {
                    name: "Tipo de Cobertura",
                    type: "label",
                    label: (_194 = (_191 = (_190 = (_189 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _189 === void 0 ? void 0 : _189.coverType) === null || _190 === void 0 ? void 0 : _190.description) !== null && _191 !== void 0 ? _191 : (_193 = (_192 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _192 === void 0 ? void 0 : _192.coverType) === null || _193 === void 0 ? void 0 : _193.name) !== null && _194 !== void 0 ? _194 : "",
                    showChangeButton: !hideChangeButton,
                },
                {
                    name: "Campaña",
                    type: "label",
                    label: (_197 = (_196 = (_195 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _195 === void 0 ? void 0 : _195.campaignId) === null || _196 === void 0 ? void 0 : _196.name) !== null && _197 !== void 0 ? _197 : "",
                },
            ];
            var afy_label_premium = (_198 = actionFlags.find(function (x) { return x.name === "afy-label-summary-premium"; })) === null || _198 === void 0 ? void 0 : _198.value;
            var labelPrice = ((_200 = (_199 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _199 === void 0 ? void 0 : _199.catalogStatusQuote) === null || _200 === void 0 ? void 0 : _200.code) !== "G"
                ? afy_label_premium !== null && afy_label_premium !== void 0 ? afy_label_premium : "Prima"
                : "Prima";
            var filtersPlan = [
                {
                    name: labelPrice,
                    type: "label",
                    label: price,
                },
            ];
            setDefaultFilters(isQuote === "false" ? __spreadArray(__spreadArray([], baseFilters, true), filtersPlan, true) : baseFilters);
            setReferrerRows([
                {
                    id: 1,
                    names: (_203 = (_202 = (_201 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _201 === void 0 ? void 0 : _201.user) === null || _202 === void 0 ? void 0 : _202.fullName) !== null && _203 !== void 0 ? _203 : "",
                    employeeCode: (_206 = (_205 = (_204 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _204 === void 0 ? void 0 : _204.user) === null || _205 === void 0 ? void 0 : _205.employeeCode) !== null && _206 !== void 0 ? _206 : "",
                    employeePosition: (_209 = (_208 = (_207 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _207 === void 0 ? void 0 : _207.user) === null || _208 === void 0 ? void 0 : _208.employeePosition) !== null && _209 !== void 0 ? _209 : "",
                    branch: (_212 = (_211 = (_210 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _210 === void 0 ? void 0 : _210.branchData) === null || _211 === void 0 ? void 0 : _211.name) !== null && _212 !== void 0 ? _212 : "",
                    quoteDate: ((_213 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _213 === void 0 ? void 0 : _213.creationDate)
                        ? formattedDate(responseOneQuote.data.creationDate)
                        : "",
                    policyDate: ((_215 = (_214 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _214 === void 0 ? void 0 : _214.policyId) === null || _215 === void 0 ? void 0 : _215.effectiveFrom)
                        ? formattedDate(responseOneQuote.data.policyId.effectiveFrom)
                        : "",
                },
            ]);
            var selectedPm = {
                id: (_217 = (_216 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _216 === void 0 ? void 0 : _216.catalogPaymentMode) === null || _217 === void 0 ? void 0 : _217.id,
                name: ((_219 = (_218 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _218 === void 0 ? void 0 : _218.catalogPaymentMode) === null || _219 === void 0 ? void 0 : _219.description) ||
                    "From Quote Response",
                value: ((_221 = (_220 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _220 === void 0 ? void 0 : _220.catalogPaymentMode) === null || _221 === void 0 ? void 0 : _221.code) ||
                    ((_223 = (_222 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _222 === void 0 ? void 0 : _222.catalogPaymentMode) === null || _223 === void 0 ? void 0 : _223.id),
            };
            callDispatchPlan(selectedPm, undefined, (_225 = (_224 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _224 === void 0 ? void 0 : _224.planId) === null || _225 === void 0 ? void 0 : _225.projectId);
        }
        dispatch(projectOneClearData());
    }, [
        responseOneQuote,
        downloadsStatusDenyList,
        isThereTabPaymentStatusAllowList,
    ]);
    useEffect(function () {
        if (responseOneProject) {
            if (id) {
                setLocalStorage(responseOneProject);
            }
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogBeneficiary && (responseGetCatalogBeneficiary === null || responseGetCatalogBeneficiary === void 0 ? void 0 : responseGetCatalogBeneficiary.data)) {
            var beneficiaryList_1 = [];
            (_a = responseGetCatalogBeneficiary.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                beneficiaryList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setBeneficiaryType(beneficiaryList_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { idTypeInsured: (_b = beneficiaryList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogBeneficiary]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (responseGetCatalogInsurance && (responseGetCatalogInsurance === null || responseGetCatalogInsurance === void 0 ? void 0 : responseGetCatalogInsurance.data)) {
            var insuranceList_1 = [];
            (_a = responseGetCatalogInsurance.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                insuranceList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                    code: (_a = item.code) !== null && _a !== void 0 ? _a : "",
                });
            });
            setInsuredType(insuranceList_1);
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { idInsuredType: (_b = insuranceList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
            // Buscar el elemento que contenga "Titular" o "titular"
            var titularItem = insuranceList_1.find(function (item) {
                return item.name.toLowerCase().includes("titular");
            });
            setInsuranceType((_d = (_c = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _c !== void 0 ? _c : insuranceList_1[0].value) !== null && _d !== void 0 ? _d : "");
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idInsuredType: (_f = (_e = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _e !== void 0 ? _e : insuranceList_1[0].value) !== null && _f !== void 0 ? _f : "" }));
        }
    }, [responseGetCatalogInsurance]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePlans) {
            var dataST_1 = [];
            // Prioritize payment mode from quote data
            var paymentModeFromQuote = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
            var pm = (_c = localStorageService.getStepStored().steps[Steps.plan]
                .paymentModeSelected) === null || _c === void 0 ? void 0 : _c.name;
            // User selection takes priority; fall back to quote data, then localStorage
            var paymentPeriod_1 = period || paymentModeFromQuote || pm;
            if (period === undefined && paymentPeriod_1) {
                setPeriod(paymentPeriod_1);
            }
            responsePlans
                .filter(function (item) { var _a, _b; return item.price && Number((_b = (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.replace(/,/g, "")) > 0; })
                .map(function (item) {
                var _a;
                dataST_1.push({
                    id: item.id,
                    name: item.name ? item.name.replace(/"/g, "") : "",
                    logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                    backgroundColor: "#ffffff",
                    currency: "$",
                    itemsValue: [],
                    option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : [], (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)),
                    period: paymentPeriod_1,
                    price: (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount,
                    textColor: "#3A56A1",
                    paymentMethod: paymentModelSelected,
                });
            });
            setPlanData(__assign(__assign({}, plan), { data: dataST_1 }));
        }
    }, [
        responsePlans,
        responseOneQuote,
        paymentModelSelected,
        coverTypeSelected,
    ]);
    useEffect(function () {
        if (listIdentificationType.length > 0 &&
            listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            listRegionLevel2.length > 0 &&
            listRegionLevel3.length > 0 &&
            !showComponent) {
            setShowComponent(true);
        }
    }, [
        listIdentificationType,
        listGenders,
        listCountries,
        listRegionLevel1,
        listRegionLevel2,
        listRegionLevel3,
    ]);
    // Sólo persiste la respuesta de la API y actualiza el estado de flags.
    // El procesamiento real ocurre en el effect de actionFlags de abajo.
    useEffect(function () {
        if (responsePageActionFlags) {
            lsPageActionFlags.setPageActionFlagsStored(responsePageActionFlags);
            setActionFlags(responsePageActionFlags);
            dispatch(pageActionFlagsClearData());
        }
    }, [responsePageActionFlags]);
    // Procesa los flags cada vez que cambian (API o localStorage al montar).
    // Esto garantiza que getActionFlags() siempre recibe los flags actuales.
    useEffect(function () {
        if (!actionFlags || actionFlags.length === 0)
            return;
        getActionFlags();
        // defaults antes del forEach
        setIsThereShowTabPaymentStatusAllowList(false);
        setShowTabPaymentStatusAllowList([]);
        setHideTabDocumentClient(isApapAuto && (isQuote === "true" || isQuote === undefined));
        actionFlags.forEach(function (actionFlag) {
            if (actionFlag.name === "afy-show-plan-travel-range-info") {
                setIsTravelInsurance(true);
            }
            if (actionFlag.name === "afy-confirm-data-downloads-status-denylist") {
                var statusdenylist_1 = JSON.parse(actionFlag.value);
                setDownloadsStatusDenyList(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(statusdenylist_1))
                        return prev;
                    return statusdenylist_1;
                });
            }
            if (actionFlag.name === "afy-confirm-data-show-tab-payment-status-allowlist") {
                setIsThereShowTabPaymentStatusAllowList(true);
                var statusallowlist_1 = JSON.parse(actionFlag.value);
                setShowTabPaymentStatusAllowList(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(statusallowlist_1))
                        return prev;
                    return statusallowlist_1;
                });
            }
            if (actionFlag.name === "afy-confirm-data-show-tab-client-documents") {
                setHideTabDocumentClient(actionFlag.value !== "true");
            }
            if (actionFlag.name === "afy-conf-holidays-rd") {
                var holidaysList_1 = JSON.parse(actionFlag.value);
                setHolidays(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(holidaysList_1))
                        return prev;
                    return holidaysList_1;
                });
            }
            if (actionFlag.name === "afy-asesor-rolid") {
                setRolAsesorId(actionFlag.value);
            }
        });
    }, [actionFlags]);
    useEffect(function () {
        if (responsePolicyConfirm && (responsePolicyConfirm === null || responsePolicyConfirm === void 0 ? void 0 : responsePolicyConfirm.data)) {
            showToastSuccessMessage("Correo enviado con éxito", typeAlert.success, setSeeToast);
            dispatch(policyConfirmClearData());
        }
    }, [responsePolicyConfirm]);
    useEffect(function () {
        if (responsePatchBeneficiary && responsePatchBeneficiary.data) {
            showToastSuccessMessage("Beneficiario actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            dispatch(patchBeneficiaryClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchBeneficiary]);
    useEffect(function () {
        var _a;
        // responsePatchQuote starts as null, becomes `true` while loading,
        // and becomes the payload (with .data) on success. Only react on success.
        if (responsePatchQuote &&
            responsePatchQuote !== true &&
            (responsePatchQuote === null || responsePatchQuote === void 0 ? void 0 : responsePatchQuote.data)) {
            showToastSuccessMessage("Cotización actualizada con éxito.", typeAlert.success, setSeeToast);
            dispatch(patchQuoteClearData());
            callQuoteOne((_a = id !== null && id !== void 0 ? id : quoteId) !== null && _a !== void 0 ? _a : "");
        }
    }, [responsePatchQuote]);
    useEffect(function () {
        if (errorPatchQuote) {
            showToastSuccessMessage("No se pudo actualizar la cotización.", typeAlert.error, setSeeToast);
            dispatch(patchQuoteClearData());
        }
    }, [errorPatchQuote]);
    useEffect(function () {
        if (responsePatchInsured && responsePatchInsured.data) {
            showToastSuccessMessage("Asegurado actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            // dispatch(person({ enable: true, page: 1, limit: 1000 }));
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchInsured]);
    useEffect(function () {
        if (responsePostInsured) {
            showToastSuccessMessage("Asegurado agregado con éxito.", typeAlert.success, setSeeToast);
            dispatch(postInsuredClearData());
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePostInsured]);
    useEffect(function () {
        if (responseUpdatePerson === null || responseUpdatePerson === void 0 ? void 0 : responseUpdatePerson.data) {
            showToastSuccessMessage("Agregado con éxito.", typeAlert.success, setSeeToast);
            // if (id !== undefined) {
            dispatch(quoteClearData());
            dispatch(quoteOne({ id: id !== null && id !== void 0 ? id : quoteId, fullBody: true }));
            // } else {
            //   dispatch(
            //     quoteOne({
            //       id: quoteId ?? id,
            //       fullBody: true,
            //     }),
            //   );
            // }
        }
    }, [responseUpdatePerson]);
    useEffect(function () {
        if (responseBenefit && (responseBenefit === null || responseBenefit === void 0 ? void 0 : responseBenefit.data)) {
            showToastSuccessMessage("Beneficiario agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModalBeneficiary(false);
            getInsuredBeneficiary();
            dispatch(benefitClearData());
        }
    }, [responseBenefit]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            /* Payment modes are now loaded from dedicated API - see useEffect for responsePaymentMode */
            /* Filtrar por coverage type */
            var result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            if (result.length > 0) {
                setCoverageType(result);
            }
            /* Filtrar por insured type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_INSURED_TYPE);
            // if (result.length > 0) {
            //   setInsuredType(result);
            //   setDataFormInsurance({
            //     ...dataFormInsurance,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
            /* Filtrar por beneficiary type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            // if (result.length > 0) {
            //   setBeneficiaryType(result);
            //   setDataFormBeneficiary({
            //     ...dataFormBeneficiary,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
        }
    }, [responsePlan]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (responseIdentificationType &&
            ((_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idf_1 = [];
            (_b = responseIdentificationType.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                idf_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setListIdentificationType(idf_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { IdType: (_c = idf_1[0].value) !== null && _c !== void 0 ? _c : "" }));
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { IdType: (_d = idf_1[0].value) !== null && _d !== void 0 ? _d : "" }));
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idType: (_e = idf_1[0].value) !== null && _e !== void 0 ? _e : "" }));
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a, _b;
        if (responseCatalogGender && ((_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCatalogGender.data) === null || _b === void 0 ? void 0 : _b.map(function (gender) {
                return {
                    id: gender.id,
                    value: gender.id,
                    name: gender.description,
                };
            });
            setListGenders(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCatalogGender]);
    useEffect(function () {
        var _a, _b;
        if (responseCountries && ((_a = responseCountries.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCountries.data) === null || _b === void 0 ? void 0 : _b.map(function (country) {
                return {
                    id: country.id,
                    value: country.id,
                    name: country.description,
                };
            });
            setListCountries(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCountries]);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    value: region.id,
                    name: region.name,
                };
            });
            data.unshift({ id: "-1", value: "-1", name: " " });
            if (responseRegion.level === level1) {
                setListRegionLevel1(data);
            }
            else if (responseRegion.level === level2) {
                if (data.length > 0) {
                    setListRegionLevel2(data);
                }
                else {
                    setListRegionLevel2([{ id: "-1", value: "-1", name: " " }]);
                }
            }
            else if (responseRegion.level === level3) {
                if (data.length > 0) {
                    setListRegionLevel3(data);
                }
                else {
                    setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
                }
            }
        }
    }, [responseRegion]);
    useEffect(function () {
        if (responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) {
            setBeneficiaryStorybook(responseBeneficiary.data);
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        if (responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) {
            setInsuranceStorybook(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data);
            setSessionData(responseInsured);
        }
    }, [responseInsured]);
    useEffect(function () {
        if (actionFlags.length > 0) {
            getActionFlags();
        }
    }, [actionFlags]);
    // Override Prima in localStorage summary with contentMap.premium when travel insurance
    useEffect(function () {
        var _a, _b;
        if (isTravelInsurance &&
            ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
            addToSummary([
                {
                    label: "Prima",
                    value: "USD ".concat(responseOneQuote.data.contentMap.premium),
                },
            ]);
        }
    }, [isTravelInsurance, (_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.contentMap) === null || _q === void 0 ? void 0 : _q.premium]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!((_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.length)) {
            setFilters(defaultFilters);
            return;
        }
        var byLabel = Object.fromEntries(summary.data.map(function (i) { return [i.label, i.value]; }));
        // Orden grupo deseado
        var header = ["Documento", "No. de cotización"];
        var cliente = ["Nombres", "Apellidos"];
        var used = new Set(__spreadArray(__spreadArray([], header, true), cliente, true));
        var producto = summary.data.filter(function (i) { return !used.has(i.label); });
        var out = __spreadArray([
            {
                name: "Número de cotización",
                label: (_b = byLabel["No. de cotización"]) !== null && _b !== void 0 ? _b : "-",
                type: "label",
            },
            {
                name: "Número de documento",
                label: (_c = byLabel["Documento"]) !== null && _c !== void 0 ? _c : "-",
                type: "label",
            },
            // Subtítulo cliente
            {
                name: "Datos del cliente",
                label: "Datos del cliente",
                type: "subtitle",
            },
            { name: "Nombres", label: (_d = byLabel["Nombres"]) !== null && _d !== void 0 ? _d : "-", type: "label" },
            { name: "Apellidos", label: (_e = byLabel["Apellidos"]) !== null && _e !== void 0 ? _e : "-", type: "label" },
            // Subtítulo producto
            {
                name: "Datos del producto",
                label: "Datos del producto",
                type: "subtitle",
            }
        ], producto.map(function (e) {
            var _a, _b;
            var labelValue = e.value;
            if (e.label === "Prima") {
                if (isTravelInsurance &&
                    ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
                    labelValue = "USD ".concat(responseOneQuote.data.contentMap.premium);
                }
                else {
                    labelValue = prime || e.value;
                }
            }
            var name = e.label;
            var showChangeButton = isQuoteType &&
                (name === "Plan" ||
                    name === "Modalidad de Pago" ||
                    name === "Tipo de Cobertura");
            return __assign({ name: name, label: labelValue, type: "label" }, (showChangeButton ? { showChangeButton: true } : {}));
        }), true);
        setFilters(out);
    }, [
        summary,
        defaultFilters,
        prime,
        isTravelInsurance,
        (_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.contentMap) === null || _s === void 0 ? void 0 : _s.premium,
    ]);
    useEffect(function () {
        if (responsePersonByDocument && responsePersonByDocument.length > 0) {
            var dataPerson = responsePersonByDocument[0];
            var updatedDataFormPerson = updateDataFormPerson(dataPerson, isInsurance ? dataFormInsurance : dataFormBeneficiary);
            if (isInsurance) {
                setDataFormInsurance(updatedDataFormPerson);
            }
            else {
                setDataFormBeneficiary(updatedDataFormPerson);
            }
            setTrigger(false);
            dispatch(personByDocumentClearData());
        }
        if ((responsePersonByDocument === null || responsePersonByDocument === void 0 ? void 0 : responsePersonByDocument.length) === 0) {
            if (isInsurance) {
                setDataFormInsurance({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            else {
                setDataFormBeneficiary({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            dispatch(personByDocumentClearData());
        }
    }, [responsePersonByDocument, isInsurance, trigger]);
    useEffect(function () {
        setUploadTrigger(false);
        setOpenDrawerUpload(false);
        dispatch(postQuoteUploadDocumentClearData());
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteId);
        }
        if (responseUploadDocuments) {
            window.dispatchEvent(new CustomEvent("pendingDocumentsChanged"));
        }
    }, [responseUploadDocuments]);
    var deleteInsured = React.useCallback(function (params) {
        var _a;
        var insuredId = (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.id;
        if (!insuredId)
            return;
        dispatch(deleteInsuredAction({
            id: insuredId,
            body: { force: false },
        }));
    }, [dispatch]);
    useEffect(function () {
        var _a;
        if (!responseDeleteInsured && !errorDeleteInsured)
            return;
        if (responseDeleteInsured) {
            dispatch(insured({
                enable: true,
                page: 1,
                limit: 100,
                quoteId: quoteId ? quoteId : id,
            }));
            setSeeToast({
                show: true,
                message: "Asegurado eliminado correctamente.",
                type: typeAlert.success,
            });
        }
        if (errorDeleteInsured) {
            setSeeToast({
                show: true,
                message: (_a = errorDeleteInsured === null || errorDeleteInsured === void 0 ? void 0 : errorDeleteInsured.message) !== null && _a !== void 0 ? _a : "No se pudo eliminar el asegurado. Intente nuevamente.",
                type: typeAlert.error,
            });
        }
        dispatch(deleteInsuredClearData());
    }, [responseDeleteInsured, errorDeleteInsured]);
    var columnsInsurance = Tab1Columns(editInsured, deleteInsured, canEditInsured, rows);
    var columnsBeneficiary = Tab2Columns(editBeneficiary, canEditBeneficiary);
    var callGetInsuredBeneficiary = function (quoteId) {
        var id_ = quoteId;
        if (id_) {
            if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) && !(responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data)) {
                dispatch(getBeneficiary({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
                dispatch(insured({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
            }
        }
    };
    // Passenger Download Modal State
    var _170 = useState(false), openPassengerModal = _170[0], setOpenPassengerModal = _170[1];
    var _171 = useState(false), openModalAddPassenger = _171[0], setOpenModalAddPassenger = _171[1];
    var _172 = useState(""), selectedQuoteId = _172[0], setSelectedQuoteId = _172[1];
    var _173 = useState(null), editingPassengerId = _173[0], setEditingPassengerId = _173[1];
    var _174 = useState(null), editingPassengerData = _174[0], setEditingPassengerData = _174[1];
    var handleAddPassanger = function () {
        setEditingPassengerId(null);
        setEditingPassengerData(null);
        setOpenModalAddPassenger(true);
    };
    var onClickPassangerDownload = React.useCallback(function () {
        setSelectedQuoteId(quoteId);
        setOpenPassengerModal(true);
    }, [quoteId]);
    var handlePassengerModalClose = React.useCallback(function () {
        setOpenPassengerModal(false);
        setSelectedQuoteId("");
    }, []);
    var handleOpenPdf = React.useCallback(function (url, name) {
        setUrlDocumentPassenger(url);
        setNameDocumentPassenger(name);
        setOpenModalPassenger(true);
    }, []);
    var _175 = React.useState(false), triggerAddAppointmentAction = _175[0], setTriggerAddAppointmentAction = _175[1];
    var columnsAppointment = TabAppointmentColumns(false, false);
    var columnsAppointmentManager = TabAppointmentManagerColumns(false, false);
    var _176 = useAppointment((_u = (_t = id !== null && id !== void 0 ? id : quoteIdLS) !== null && _t !== void 0 ? _t : quoteId) !== null && _u !== void 0 ? _u : "", showTabAppointment), appointmentRows = _176.appointmentRows, appointmentId = _176.appointmentId, setAppointmentRows = _176.setAppointmentRows, setExecutiveUserId = _176.setExecutiveUserId, setAppointmentId = _176.setAppointmentId, executiveUserId = _176.executiveUserId, loadingGetAppointmentAction = _176.loadingGetAppointmentAction, callAppointment = _176.callAppointment;
    var _177 = useAppointmentManager(appointmentId, setOpenModalAddAppointmentAction, setTriggerAddAppointmentAction, triggerAddAppointmentAction, showTabAppointmentManager, (_v = lsLogin.getUserLoginStored().user.id) !== null && _v !== void 0 ? _v : "", setSeeToast, holidays, appointmentRows, quoteId, executiveUserId, setAppointmentRows, setAppointmentId, setExecutiveUserId, rolAsesorid, callQuoteOne, (_x = (_w = id !== null && id !== void 0 ? id : quoteIdLS) !== null && _w !== void 0 ? _w : quoteId) !== null && _x !== void 0 ? _x : "", callAppointment), appointmentManagerRows = _177.appointmentManagerRows, handleAddAppointmetAction = _177.handleAddAppointmetAction, handleSubmitAppointmentAction = _177.handleSubmitAppointmentAction, formAppointmentActionProps = _177.formAppointmentActionProps, loadingAppointmentActionPatch = _177.loadingAppointmentActionPatch, loadingAppointmentPost = _177.loadingAppointmentPost, quotePriceLoading = _177.quotePriceLoading;
    var effectiveQuoteId = id ? id : quoteId;
    var loggedUser = lsLogin.getUserLoginStored();
    var loggedUserId = (_0 = (_z = (_y = loggedUser.user) === null || _y === void 0 ? void 0 : _y.id) !== null && _z !== void 0 ? _z : loggedUser.userId) !== null && _0 !== void 0 ? _0 : "";
    var loggedUserName = [
        (_2 = (_1 = loggedUser.idToken) === null || _1 === void 0 ? void 0 : _1.payload) === null || _2 === void 0 ? void 0 : _2.name,
        (_4 = (_3 = loggedUser.idToken) === null || _3 === void 0 ? void 0 : _3.payload) === null || _4 === void 0 ? void 0 : _4.family_name,
    ]
        .filter(Boolean)
        .join(" ")
        .trim() || loggedUser.userName;
    var currentCreatorType = "manager";
    var _178 = useQuoteComments({
        quoteId: effectiveQuoteId,
        currentUserId: loggedUserId,
        currentUserName: loggedUserName,
        currentCreatorType: currentCreatorType,
        showComments: showComments,
        setSeeToast: setSeeToast,
        t: t,
    }), quoteComments = _178.comments, loadingPostComment = _178.loadingPostComment, loadingPutComment = _178.loadingPutComment, loadingDeleteComment = _178.loadingDeleteComment, loadingGetComments = _178.loadingGetComments, handleAddComment = _178.addComment, handleUpdateComment = _178.updateComment, handleDeleteComment = _178.deleteComment;
    var _179 = useAuditLogs({
        enable: showLogsInfo && !!effectiveQuoteId,
        page: 0,
        size: 100,
        orderDir: "ASC",
        quoteId: effectiveQuoteId,
        setSeeToast: setSeeToast,
        t: t,
    }), auditLogEntries = _179.logEntries, loadingGetAuditLogs = _179.loadingGetAuditLogs;
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: titleInsured, hideStep: isQuote === "false", steps: steps, completed: isQuote === "false" || isLastPage }), _jsx(ConfirmationHeader, { loading: loadingPostInsured ||
                    loadingUpdatePerson ||
                    loadingOneQuote ||
                    loadingBenefit ||
                    loadingPostInsured ||
                    loadingPatchBeneficiary ||
                    loadingPatchInsured ||
                    loadingPersonByDocument ||
                    loadingOneProject ||
                    loadingBeneficiary ||
                    loading ||
                    loadingPlans ||
                    loadingUpdateQuote ||
                    loadingUploadDocuments ||
                    loadingGetCatalogBeneficiary ||
                    loadingGetCatalogInsurance ||
                    loadingCertificateQuote ||
                    loadingInsured ||
                    loadingPaymentMode ||
                    loadingComplete ||
                    loadingCatalogues ||
                    loadingStartWorkFlow ||
                    loadingPatchQuote ||
                    loadingAppointmentActionPatch ||
                    loadingPostComment ||
                    loadingPutComment ||
                    loadingDeleteComment ||
                    loadingGetComments ||
                    responsePolicyConfirmLoading ||
                    loadingAppointmentPost ||
                    loadingGetAppointmentAction ||
                    quotePriceLoading, text: loadingUpdatePerson || loadingUpdateQuote || loadingPatchQuote
                    ? "Actualizando cotización..."
                    : loadingUploadDocuments
                        ? "Subiendo documento..."
                        : "Cargando...", seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), openPassengerModal && (_jsx(PassengerDownloadModal, { open: openPassengerModal, onClose: handlePassengerModalClose, setSeeToast: setSeeToast, quoteId: selectedQuoteId, onOpenPdf: handleOpenPdf })), showComponent ? (_jsx(Suspense, { children: _jsx(ConfirmationFormView, { onClickPassangerDownload: onClickPassangerDownload, isTravelInsurance: isTravelInsurance, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, breadcrumbs: breadCrumbs, steps: steps, 
                    /* PDF VIEWER DOCUMENT*/
                    openModal: openModalPdfViewer, setOpenModal: setopenModalPdfViewer, documentName: nameDocument, urlDocument: urlDocument, 
                    /* PDF VIEWER CLIENT*/
                    openModalClient: modalDocumentClient, setOpenModalClient: setModalDocumentClient, documentNameClient: docName, urlDocumentClient: urlDocumentClient, 
                    /* PDF VIEWER PASSENGER */
                    openModalPassenger: openModalPassenger, setOpenModalPassenger: setOpenModalPassenger, documentNamePassenger: nameDocumentPassenger, urlDocumentPassenger: urlDocumentPassenger, 
                    /* MODAL EDIT VEHICLE */
                    openModalEditVehicle: openModalEditVehicle, setOpenModalEditVehicle: setOpenModalEditVehicle, dataFormVehicle: dataFormVehicle, callQuoteOneApi: callQuoteOne, quoteId: id ? id : quoteId, planId: planId, coverTypeId: coverTypeId, campaignId: campaignId, catalogPaymentMode: catalogPaymentMode, catalogStatusQuote: catalogStatusQuote, branchId: branchId, userId: userId, idQuoteVehicle: idQuoteVehicle, productId: productId, t: t, planName: planName, productType: productType, projectTypeLocal: projectTypeLocal, salesFlow: salesFlow, 
                    /* MODAL BENEFICIARY */
                    openModalBeneficiary: openModalBeneficiary, setOpenModalBeneficiary: setOpenModalBeneficiary, isMaskedDocument: isMaskedDocument, dataFormBeneficiary: dataFormBeneficiary, titleBeneficiary: titleBeneficiary, beneficiaryType: beneficiaryType, listIdentificationType: listIdentificationType, initialPercentage: initialPercentage, handleSubmitBeneficiary: function () {
                        return handleSubmitBeneficiary(dataFormBeneficiary);
                    }, searchPerson: function (e) {
                        return searchPerson(e, setIsInsurance, setDocument, setTrigger);
                    }, 
                    /* MODAL INSURED */
                    openModalInsured: openModal, setOpenModalInsured: setOpenModal, dataFormInsurance: dataFormInsurance, titleInsured: titleInsured, insuredType: insuredType, handleSubmitInsured: function (data) { return handleSubmitInsured(data); }, searchInsurancePerson: function (e) { return searchInsurancePerson(e); }, 
                    /* MODAL CONFIRMATION */
                    openModalBackConfirm: openModalBackConfirm, handleCloseBackModal: handleCloseBackModal, handleBackFromModal: handleBackFromModal, classes: classes, 
                    /* VIEW */
                    isRequired: !isApap, tabAdditionalDocumentation: "Documentos Clientes", countBadgeContent: countBadge, customBadgeColor: "#fba730", badgeColorText: "#ffffff", additionalDocumentationColumns: AdditionalDocumentationColumns(handleClickContextMenu), additionalDocumentationRows: profileDocumentsRows, hideMarriedName: hideMarriedName, titleDrawer: "Suba el documento solicitado.", descriptionDrawer: "Arrastra el documento solicitado a la zona de color o haz clic en el área de color para seleccionarlo. Solo puedes subir un documento a la vez, y solo se permiten archivos en formato PDF.", titleUpload: "Arrastre y suelte su archivo.", heightDrawer: "100%", disableSelectCountry: true, openDrawerUpload: openDrawerUpload, onCloseDrawer: function () {
                        setOpenDrawerUpload(false);
                    }, onUpload: quoteUploadDocuments, tabAuto: "Auto Asegurado", tabAutoDescription: "", tabStatement: "Estado de cuenta", tabStatementColumns: StatementColumns(t), tabStatementRows: statementRows, TabAutoColumns: TabAutoColumns(updateVehicle, isQuote ? isQuote : ""), TabAutoRows: listVehiclesDetail, onChangeSelect: handleChangeSelect, handleChangeSelectFormInsurance: handleChangeSelectFormInsurance, 
                    // ***--- PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    onClickAutoDownload: handleOnClickAutoDownload, btnLblDownload: "Descargar Cotización", btnDownloadQuoteBackground: "#ffffff", showButtonDownloadApap: !showVehicleData || !showDownloadQuote, onClickAutoDownloadVida: handleOnClickAutoDownloadVida, btnLblDownloadVida: "Descargar Solicitud", showButtonDownloadVida: !showDownloadRequest, 
                    // ***--- END PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    labelNumberQuote: ((_5 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _5 === void 0 ? void 0 : _5.policyId)
                        ? "No. de póliza"
                        : "No. de cotización", title: "Confirmación de datos", identificationList: listIdentificationType, GenderList: listGenders, CountryList: listCountries, ProvinceList: listRegionLevel1, TownList: listRegionLevel2, SectorList: listRegionLevel3, dataForm: dataForm, hideTabs: [
                        showInsured,
                        showBeneficiary,
                        hideTabPaymentInfo,
                        showVehicleData,
                        true,
                        false,
                        !isTravelInsurance,
                        showTabRealEstates,
                        !showTabAppointment,
                        !showTabAppointmentManager,
                        !showTabReferrer,
                        !showComments,
                        false,
                    ], hideAddButton: [
                        addInsured,
                        addBeneficiary,
                        true,
                        true,
                        !addAppointmentAction,
                    ], showAdd: true, showActions: canEdit, showContactActions: canEditContact, showLocationActions: canEditLocation, showDownloads: showDownloads, onClickDownload: handleDownload, certificates: certificates, dateLabel: isQuote !== null && isQuote === "false"
                        ? "Fecha efectiva"
                        : "Fecha de cotización", downloadsTitle: "Descargas", labelAdd: "Agregar", tab1: "Personas aseguradas", tab1Description: "Asegurados", tab2: "Beneficiarios", tab2Description: "Beneficiarios", tab3: "Información de pago", tab3Description: "", Tab1Columns: columnsInsurance, Tab1Rows: rows, Tab2Columns: columnsBeneficiary, Tab2Rows: rowsBeneficiary, Tab3Columns: Tab3Columns, Tab3Rows: rows2, 
                    //Travel Insurance Tab4
                    tab4: "Pasajeros", 
                    /////
                    Tab4Columns: Tab4Columns, Tab4Rows: rowsPassengers, hide2: true, options1: paymentMode, options2: [], options3: campaignInfo, firstSubtitle: "Información de cotización", secondSubtitle: "Información general del cliente", thirdSubtitle: "Información de ubicación", fourthSubtitle: "Información de contacto", plan: ((paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                        catalogPaymentMode &&
                        paymentModelSelected.id !== catalogPaymentMode) ||
                        (((coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)) &&
                            coverTypeId &&
                            ((coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)) !==
                                coverTypeId)
                        ? __assign(__assign({}, plan), { id: "" }) : plan, plans: planData.data || [], paymentMethodData: paymentMode, campaignData: campaign, showPaymentMethod: true, showCampaign: true, onClickAdd: handleAddInsured, onClickRowGrid: function () { }, onClickAddBeneficiary: handleAddBeneficiary, filters: filters, titleSelectButton: "Adquirir", previousLabel: "Anterior", nextLabel: !isVidaTermino ? "Siguiente" : "Finalizar", showPrevious: canEdit, nextDisabled: !permissions.create || !canEdit || (navigation === null || navigation === void 0 ? void 0 : navigation.canNavigateNext) === false, onBack: onClickBack, onClickSave: handleUpdatePerson, onNext: handleNext, onClickPrevious: handlePrevious, onBlurInput: function () { }, onChangeInput: function () { }, onClickCancel: function () { }, disableDocumentType: true, disableDocumentNumber: true, onChangePaymentMethod: handleOnChangePaymentMethod, onChangeCampaign: handleOnChangeCampaign, onChangeCoverType: handleOnChangeCoverType, onClickAcquire: handleOnClickAcquire, disabledDownloadVida: false, isQuote: isQuote, isPlan: isPlan, openModalAddInsurance: openModalAddInsurance, setOpenModalAddInsurance: setOpenModalAddInsurance, dataFormInsuranceSp: dataFormInsuranceSp, showButtonActivatePolicy: showButtonActivatePolicy, openActivePolicy: openActivePolicy, setOpenActivePolicy: setOpenActivePolicy, policyId: policyId, callQuoteOne: callQuoteOne, onClickAddPassanger: handleAddPassanger, openModalAddPassenger: openModalAddPassenger, setOpenModalAddPassenger: setOpenModalAddPassenger, editingPassengerData: editingPassengerData, handleSavePassenger: function () { }, 
                    //home/business
                    setOpenModalAddBusiness: setOpenModalAddBusiness, openModalAddBusiness: openModalAddBusiness, isCommerce: isCommerce, tab4Description: "", TabRealEstateRows: rowsProperties, dataFormBusiness: dataFormBusiness, damageBackup: damageBackup, insuredProperty: insuredProperty, showFormBusiness: showFormBusiness, openModalAddHome: openModalAddHome, setOpenModalAddHome: setOpenModalAddHome, onSameDirection: onSameDirection, productCode: productCode, planCode: planCode, setDataFormBusiness: setDataFormBusiness, businessShift: businessShift, businessType: businessType, typeConstruction: typeConstruction, 
                    // END home/business
                    //Appoinment
                    tabAppointment: "Cita", tabAppointmentDescription: "Información de Cita", tabAppointmentColumns: columnsAppointment, tabAppointmentRows: appointmentRows, 
                    //AppointmentManager
                    tabAppointmentManager: "Gestiones", tabAppointmentManagerDescription: "Gestiones", tabAppoinmentManagerColumns: columnsAppointmentManager, tabAppointmentManagerRows: appointmentManagerRows, onClickAddAppAction: handleAddAppointmetAction, openModalAddAppointmentAction: openModalAddAppointmentAction, setOpenModalAddAppointmentAction: setOpenModalAddAppointmentAction, handleSubmitAppointmentAction: handleSubmitAppointmentAction, formAppointmentActionProps: formAppointmentActionProps, showBranchSwitcher: !!((_6 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _6 === void 0 ? void 0 : _6.id), branchSwitcherCardTitle: "Sucursal", branchDisplayLabel: branchDisplayLabelForSwitcher, branchOptions: branchSwitcherOptions, selectedBranchId: (_8 = (_7 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _7 === void 0 ? void 0 : _7.branch) !== null && _8 !== void 0 ? _8 : "", branchSwitcherDisabled: !permissions.create || loadingPatchQuote, branchSwitcherLoading: loadingPatchQuote, onBranchChange: handleBranchChange, branchSwitcherModalTitle: "Cambiar sucursal", referrerRows: referrerRows, currentUserId: loggedUserId, currentCreatorType: currentCreatorType, currentUserIsAdmin: false, comments: quoteComments, onAddComment: handleAddComment, onUpdateComment: handleUpdateComment, onDeleteComment: handleDeleteComment, commentsLabels: {
                        title: "Comentarios del expediente",
                        description: "Discusión interna",
                        placeholder: "Escribe un comentario...",
                        send: "Enviar",
                        cancel: "Cancelar",
                        reply: "Responder",
                        edit: "Editar",
                        delete: "Eliminar",
                        save: "Guardar",
                        attach: "Adjuntar",
                        emptyState: "Sin comentarios todavía",
                        inReplyTo: "Respondiendo a",
                        edited: "editado",
                        preview: "Vista previa",
                        download: "Descargar",
                        confirmDelete: "¿Eliminar este comentario?",
                        fileTooLarge: "Archivo demasiado grande",
                        fileTypeNotAllowed: "Tipo de archivo no permitido",
                        contentRequired: "El comentario no puede estar vacío",
                    }, tabLog: "Bit\u00E1cora", tabLogProps: {
                        showLogNumbers: false,
                        logMaxHeight: "220px",
                        tabLogDescription: "Bitácora de eventos.",
                        logEntries: loadingGetAuditLogs
                            ? ["Cargando bitácora..."]
                            : auditLogEntries.length > 0
                                ? auditLogEntries
                                : ["Sin eventos registrados."],
                    }, 
                    //CHANGE PAYMENT METHOD
                    showPaymentMethodCard: !!policyId && policyStatus.toLowerCase() === "activa", filterPaymentMethod: paymentMethodCardData, titlePaymentMethodCard: "Método de pago", onClickChangePaymentMethod: function () {
                        navigate("/checkout/payment-method/".concat(quoteId));
                    }, 
                    // END CHANGE PAYMENT METHOD
                    // sendMail
                    showSendEmailBox: !!policyId, defaultEmail: email, onClickSendEmail: handleSendEmail }) })) : (_jsx("div", {}))] }));
};
export default ConfirmationForm;
